<template>
	<div class="grid p-fluid">
        <Toast/>
        <!-- Aviso fijo mientras Contablus espera al SRI (ver service/sriPendingToast.js) -->
        <Toast group="sriPending"/>
        <div class="col-12">
			<div class="card" :style="{'background-color':this.cardBackgroundColor}">
                <div style="width: 100%; display: flex;">
                    <h2 style="font-size: large;">{{ (this.purchase.edoc === null) ? "Compra/Gasto" : "Comprobante de Retención" }} - {{ this.$store.getters.defaultActivity.name }}</h2>
                    <Button label="Nueva" v-show="showNewButton" icon="pi pi-plus" class="p-button-raised p-button-success mr-2 mb-2" style="width: 100px; margin-left: auto;" @click="newPurchase"/>
                </div>
				<div class="p-fluid formgrid grid">
                    <div class="field col-12">
                        <div class="grid formgrid" style="margin-top: 10px;">
                            <div class="col-12">
                                <div class="card">
                                    <h5><b>Seleccione el tipo de registro</b></h5>
                                    <div class="formgrid grid" style="margin-bottom: 1.5rem; row-gap: 0.5rem; align-items: center;">
                                        <div class="col-12 md:col-6">
                                            <Dropdown v-model="selectedRecord" :options="recordTypes" optionLabel="name" :disabled="this.purchase.id !== null"/>
                                        </div>
                                        <div class="col-6 md:col-3 xmlUploadField" v-show="this.selectedRecord.code === 'purchase' && this.purchase.id === null">
                                            <FileUpload ref="xmlUpload" mode="basic" id="xmlInput" name="xml[]" accept=".xml" chooseLabel="Cargar XML" chooseIcon="pi pi-upload" :maxFileSize="1000000" customUpload @select="onXMLUploaded" @uploader="clearPurchase" />
                                        </div>
                                        <div class="col-6 md:col-3" v-show="this.selectedRecord.code === 'purchase' && this.purchase.id === null">
                                            <Button label="Descargar del SRI" icon="pi pi-cloud-download" class="p-button-outlined w-full" @click="openSriDownloadDialog" />
                                        </div>
                                    </div>

                                    <!-- Popup: descargar XML de compra desde el SRI por clave de acceso -->
                                    <Dialog v-model:visible="sriDialogVisible" :modal="true" :closable="!sriDownloading" header="Descargar XML del SRI" :style="{width: '480px'}">
                                        <div class="p-fluid">
                                            <p style="margin-bottom: 1rem; color: #6c757d;">
                                                Ingresa la clave de acceso de 49 dígitos del comprobante recibido. Se descargará el XML desde el SRI y se autocompletará el formulario.
                                            </p>
                                            <div class="field">
                                                <label for="sriAccessCode">Clave de acceso (49 dígitos)</label>
                                                <InputText id="sriAccessCode" v-model="sriAccessCode" :disabled="sriDownloading" maxlength="49" placeholder="49 dígitos" @keyup.enter="downloadFromSri" />
                                                <small class="p-invalid" v-if="sriAccessCode && sriAccessCode.replace(/\D/g,'').length !== 49">La clave debe tener 49 dígitos ({{ sriAccessCode.replace(/\D/g,'').length }}/49).</small>
                                            </div>
                                            <div v-if="sriDownloading" style="display:flex; align-items:center; gap:0.5rem; margin-top:0.5rem; color:#27285c;">
                                                <i class="pi pi-spin pi-spinner" style="font-size:1.25rem;"></i>
                                                <span>Descargando desde el SRI… esto puede tardar hasta dos minutos.</span>
                                            </div>
                                            <!-- Respuesta del proceso, anclada al popup (persistente, no toast) -->
                                            <InlineMessage v-if="sriMessage && !sriDownloading" :severity="sriMessageSeverity" class="w-full mt-3" style="justify-content:flex-start; text-align:left;">{{ sriMessage }}</InlineMessage>
                                        </div>
                                        <template #footer>
                                            <Button label="Cancelar" icon="pi pi-times" class="p-button-text" :disabled="sriDownloading" @click="sriDialogVisible = false" />
                                            <Button label="Descargar" icon="pi pi-cloud-download" :loading="sriDownloading" :disabled="sriDownloading" @click="downloadFromSri" />
                                        </template>
                                    </Dialog>
                                    
                                    <!-- Bloqueo: la clave de acceso del XML ya esta registrada como compra -->
                                    <Dialog v-model:visible="duplicateDialogVisible" :modal="true" :closable="false" header="Esta factura ya fue ingresada" :style="{width: '520px'}">
                                        <div class="p-fluid">
                                            <p style="margin-bottom: 1rem;">
                                                La clave de acceso del comprobante ya está registrada como una compra de este negocio.
                                                Una misma factura de proveedor no se puede ingresar dos veces, así que el formulario se va a limpiar.
                                            </p>
                                            <div v-if="duplicatePurchase && duplicatePurchase.id" style="background-color:#f8f9fa; border-radius:6px; padding:0.75rem 1rem;">
                                                <div style="display:flex; justify-content:space-between; gap:1rem; padding:0.15rem 0;">
                                                    <span style="color:#6c757d;">Documento</span>
                                                    <b>{{ duplicatePurchase.serialNumber }}</b>
                                                </div>
                                                <div v-if="duplicatePurchase.vendorName" style="display:flex; justify-content:space-between; gap:1rem; padding:0.15rem 0;">
                                                    <span style="color:#6c757d;">Proveedor</span>
                                                    <b style="text-align:right;">{{ duplicatePurchase.vendorName }}</b>
                                                </div>
                                                <div style="display:flex; justify-content:space-between; gap:1rem; padding:0.15rem 0;">
                                                    <span style="color:#6c757d;">Fecha</span>
                                                    <b>{{ duplicatePurchaseDate }}</b>
                                                </div>
                                                <div style="display:flex; justify-content:space-between; gap:1rem; padding:0.15rem 0;">
                                                    <span style="color:#6c757d;">Total</span>
                                                    <b>${{ duplicatePurchase.total }}</b>
                                                </div>
                                            </div>
                                            <p style="margin-top:1rem; margin-bottom:0; color:#6c757d;">
                                                Para corregir algún dato, <strong>anula primero la compra vigente</strong>
                                                desde el listado de Egresos. Una vez anulada, podrás volver a ingresar
                                                la factura con la información correcta.
                                            </p>
                                        </div>
                                        <template #footer>
                                            <Button label="Entendido" icon="pi pi-check" @click="acknowledgeDuplicatePurchase" />
                                        </template>
                                    </Dialog>

                                    <div class="p-fluid" v-show="this.selectedRecord.code === 'purchase'">

                                        <div class="formgrid grid">
                                            <div class="field col-12 md:col-6">
                                                <label for="vendorName" style="margin-bottom: 5px;">Razón Social / Proveedor</label>
                                                <AutoComplete placeholder="Razón Social / Proveedor" id="productProvider" :disabled="this.purchase.id !== null" :dropdown="true" :multiple="false" v-model="this.purchase.vendorName" :suggestions="providers" @complete="searchProvider($event)" @item-select="onProviderSelected($event)" field="company"/>
                                            </div>
                                            <div class="field col-12 md:col-6">
                                                <label for="vendorId" style="margin-bottom: 5px;">CI / R.U.C.</label>
                                                <InputText placeholder="Identificación" id="productProvider" :disabled="this.purchase.id !== null" v-model="this.purchase.vendorIdentification"/>
                                            </div>
                                        </div>


                                        <div class="formgrid grid">
                                            <div class="field col-12 md:col-6">
                                                <label style="margin-bottom: 5px;">Serie de Factura</label>
                                                <div style="display: flex; gap: 5px;">
                                                    <InputText v-model="this.establishmentCode" placeholder="001" id="establishment" type="text" maxlength="3" autofocus :disabled="this.purchase.id !== null" style="width: 25%;" :change="onSerialNumberChanged()"/>
                                                    <InputText v-model="this.emitionPointCode" placeholder="001" id="emitionPoint" type="text" maxlength="3" autofocus :disabled="this.purchase.id !== null" style="width: 25%;" :change="onSerialNumberChanged()"/>
                                                    <InputText v-model="this.serialNumber" placeholder="000000001" id="serialNumber" type="text" maxlength="9" autofocus :disabled="this.purchase.id !== null" style="width: 50%;" :change="onSerialNumberChanged()"/>
                                                </div>
                                            </div>
                                            <div class="field col-12 md:col-6">
                                                <label style="margin-bottom: 5px;">Fecha de Emisión</label>
                                                <Calendar v-model="this.purchase.createdAt" :disabled="this.purchase.id !== null" placeholder="dd/mm/yyyy hh:mm" :showTime="true" :showSeconds="false" hourFormat="24"></Calendar>
                                            </div>
                                        </div>

                                        <div class="formgrid grid">
                                            <div class="field col-12">
                                                <label style="margin-bottom: 5px;">Clave de acceso</label>
                                                <InputText v-model="this.purchase.accessCode" id="accessCode" type="text" maxlength="49" autofocus :disabled="this.purchase.id !== null"/>
                                            </div>
                                        </div>


                                        <div class="formgrid grid" v-show="(this.business.makesRetention === true || this.purchase.hasRetention === true)">
                                            <div class="field col-12 md:col-6">
                                                <label style="margin-bottom: 5px;">Porcentaje de Retención de RENTA</label>
                                                <Dropdown v-model="this.purchase.rentPercentage" :options="this.purchase.rentPercentageOptions" :disabled="this.purchase.id !== null" optionLabel="name" placeholder="Seleccione % retención..."/>
                                            </div>
                                            <div class="field col-12 md:col-6">
                                                <label style="margin-bottom: 5px;">Porcentaje de Retención de IVA</label>
                                                <Dropdown v-model="this.purchase.ivaPercentage" :options="this.purchase.ivaPercentageOptions" :disabled="this.purchase.id !== null" optionLabel="name" placeholder="Seleccione % retención..."/>
                                            </div>
                                        </div>

                                        <div class="formgrid grid" v-show="this.purchase.receiptXMLUrl !== null">
                                            <div class="col-12">
                                                <DataTable v-if="this.receiptItems.length > 0" :value="this.receiptItems" scrollable>
                                                    <Column field="codigoPrincipal" header="Cod. Príncipal"></Column>
                                                    <Column field="descripcion" header="Descr."></Column>
                                                    <Column field="cantidad" header="Cant.">
                                                        <template #body="slotProps">
                                                            {{ formatUnitPrice(slotProps.data.cantidad) }}
                                                        </template>
                                                    </Column>
                                                    <Column field="precioUnitario" header="Precio Unit.">
                                                        <template #body="slotProps">
                                                            {{ formatUnitPrice(slotProps.data.precioUnitario) }}
                                                        </template> 
                                                    </Column>
                                                    <Column field="descuento" header="Dscto."></Column>
                                                    <Column field="precioTotalSinImpuesto" header="Total">
                                                        <template #body="slotProps">
                                                            {{ slotProps.data.precioTotalSinImpuesto.toFixed(2) }}
                                                        </template>
                                                    </Column>
                                                    <Column field="impuesto" header="">
                                                        <template #body="slotProps">
                                                            {{ (slotProps.data.impuesto) ? "i" : "" }}
                                                        </template>
                                                    </Column>
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="expenseDetailContainer p-fluid" v-show="this.selectedRecord.code === 'expense'">
                                        <div class="col-12 mb-2 lg:col-3 lg:mb-0 md:col-3" style="padding-left: 0px;">
                                            <label for="customerName" style="margin-bottom: 5px;">Fecha de Creación</label>
                                            <Calendar v-model="this.purchase.createdAt" :disabled="this.purchase.id !== null" placeholder="dd/mm/yyyy hh:mm" :showTime="true" :showSeconds="false" hourFormat="24"></Calendar>
                                        </div>
                                        <div class="col-12 mb-2 lg:col-9 lg:mb-0 md:col-9">
                                            <label for="customerId"  style="margin-bottom: 5px;">Descripción</label>
                                            <InputText v-model="this.purchase.reason" placeholder="Descripción de compra/gasto" id="customerId" type="text" autofocus @change="checkForm()" :disabled="this.purchase.id !== null" />
                                        </div>
                                    </div>
                                </div>
                                <div class="grid formgrid" style="margin-top: 20px;" v-show="this.purchase.id === null || this.purchase.items.length > 0">
                                    <div class="col-12">
                                        <div class="card">
                                            <h5><b>Reportar Inventario de Producto(s)</b></h5>
                                            <Button icon="pi pi-search" v-if="this.purchase.id === null" class="p-button-rounded p-button-info mr-2 mb-2" style="position: absolute; top: 15px; right: 20px;" @click="showProductDialog"/>
                                            <DataTable :value="this.purchase.items" editMode="cell" :scrollable="true" scrollHeight="400px" scrollDirection="both" class="mt-3 editable-cells-table">
                                                <Column field="productId" header="Cód." :style="{width: '10%','min-width':'50px'}">
                                                    <template #body="slotProps">
                                                        {{ slotProps.data.code !== undefined && slotProps.data.code !== null ? slotProps.data.code : slotProps.data.productId  }}
                                                    </template>
                                                </Column>
                                                <Column field="amount" header="Cant." :style="{width: '12.5%','min-width':'100px'}">
                                                    <template #editor="{data, field}" v-if="this.purchase.id === null">
                                                        <InputText v-model="data[field]" type="number" autofocus :disabled="this.purchase.id !== null" @change="onAmountChanged(data)"/>
                                                    </template>
                                                </Column>
                                                <Column field="product" header="Descr." :style="{width: '30%','min-width':'75px'}"></Column>
                                                <Column field="readableTax" header="IVA" :style="{width: '10%','min-width':'50px'}"></Column>
                                                <Column field="unitPrice" header="Precio Unit." :style="{width: '12.5%','min-width':'50px'}">
                                                    <template #editor="{data, field}" v-if="this.purchase.id === null">
                                                        <InputText v-model="data[field]" type="number" autofocus :disabled="this.purchase.id !== null" @change="onUnitPriceChanged(data)"/>
                                                    </template>
                                                </Column>
                                                <Column field="readableDiscount" header="Descto. %" :style="{width: '12.5%','min-width':'100px'}">
                                                    <template #editor="{data, field}" v-if="this.purchase.id === null">
                                                        <InputText v-model="data[field]" type="number" autofocus :disabled="this.purchase.id !== null" @change="onDiscountChanged(data)"/>
                                                    </template>
                                                </Column>
                                                <Column field="totalPrice" header="Precio Final" :style="{width: '10%','min-width':'50px'}">
                                                    <template #body="slotProps">
                                                        {{(slotProps.data.totalPrice).toFixed(2)}}
                                                    </template>
                                                </Column>
                                                <Column :exportable="false" style="width: 50px;">
                                                    <template #body="item" v-if="this.purchase.id === null">
                                                        <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text mr-2 mb-2"  @click="onItemDeleted(item)"/>
                                                    </template>
                                                </Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>

                                <div class="grid formgrid">
                                    <div class="col-12">
                                        <div class="card">
                                            <h5><b>Plazo, Método de Pago y Valores</b></h5>
                                            <div class="p-fluid formgrid grid">
                                                <div class="field col-12 md:col-6">
                                                    <h5 v-if="this.purchase.id === null || (this.purchase.id !== null && this.purchase.observations)">Observaciones</h5>
                                                    <ObservationsField v-if="this.purchase.id === null || (this.purchase.id !== null && this.purchase.observations)" :disabled="this.purchase.id !== null" :maxLength="observationsMaxLength" v-model="this.purchase.observations" style="margin-bottom: 10px;"/>
                                                    <!-- Clasificar egresos es una funcion de Contabilidad: el campo aparece
                                                         cuando hay categorias mapeadas en Contabilidad > Mapeos. Tambien si la
                                                         compra ya trae una categoria vieja, para no mostrarla en blanco. -->
                                                    <div class="col-12 mb-2 lg:col-12" style="margin-bottom: 5px;" v-if="expensesType.length || selectedExpenseType">
                                                        <h5 style="margin-bottom: 5px;">Tipo de Gasto</h5>
                                                        <Dropdown v-model="this.selectedExpenseType" :options="expensesType" optionLabel="name" placeholder="Seleccione una opción" :disabled="this.purchase.id !== null"/>
                                                        <small v-if="!expensesType.length" style="color:#888;">
                                                            Categoría heredada. Las nuevas se definen en Contabilidad › Mapeos.
                                                        </small>
                                                    </div>
                                                    <!-- Tipo de gasto basico (sin Contabilidad): lista fija, lo habilita el
                                                         setting egreso_expenseType. Si hay categorias mapeadas manda
                                                         Contabilidad y este se oculta. -->
                                                    <div class="col-12 mb-2 lg:col-12" style="margin-bottom: 5px;" v-if="showBasicExpenseType">
                                                        <h5 style="margin-bottom: 5px;">Tipo de Gasto</h5>
                                                        <Dropdown v-model="this.selectedBasicExpenseType" :options="basicExpensesType" optionLabel="name" placeholder="Seleccione una opción" :disabled="this.purchase.id !== null"/>
                                                    </div>
                                                    <div class="paymentContainer">
                                                        <div class="col-12 mb-2 lg:col-6 lg:mb-0">
                                                            <h5>Plazo</h5>
                                                            <div class="paymentSubcontainer">
                                                                <div style="width: 100%;">
                                                                    <Dropdown v-model="creditDay" :options="creditDays" optionLabel="name" @change="onCreditDaysChanged" placeholder="Días de plazo" :disabled="this.purchase.id !== null" />
                                                                    <label style="margin-bottom: 10px;" v-if="this.purchase.creditDays>0"><i :style="{'color' : (this.purchase.collectStatusReadable === 'VENCIDA') ? 'red' : 'black'}">{{this.purchase.collectStatusReadable === "VENCIDA" ? 'Vencida' : 'Vence'}} el {{ this.purchase.dueDateFormatted }}</i></label>
                                                                </div>
                                                                <div class="collectButton" v-if="!this.purchase.isNulled && (this.purchase.id !== null && this.purchase.creditDays>0)">
                                                                    <Button :label="(this.purchase.collectStatusReadable === 'PAGADA') ? 'Pagado' : 'Pagar'" :icon="(this.purchase.collectStatusReadable === 'PAGADA') ? 'pi pi-check' : ''" :class="{'p-button-outlined': this.purchase.collectStatusReadable === 'PAGADA', 'p-button-success': true, 'mr-2': true, 'mb-2': true}" :disabled="this.purchase.collectStatusReadable === 'PAGADA'" @click="payPurchase()" :loading="this.loadingCollectButton"/>
                                                                    <Button v-if="this.purchase.collectStatusReadable !== 'PAGADA'" label="Abonar" icon="pi pi-wallet" class="p-button-raised p-button-warning mr-2 mb-2" @click="abonarPurchase()"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                                        <h5 style="margin-bottom: 5px;">Método de Pago</h5>
                                                        <Dropdown v-model="this.purchase.paymentMethod" :options="paymentMethods" optionLabel="name" placeholder="Forma de pago" :disabled="this.purchase.id !== null"/>
                                                        <div v-if="this.purchase.id !== null && hasAccountability" style="margin-top: 8px;">
                                                            <a @click="viewTransaction" style="cursor: pointer; color: #18407f; text-decoration: underline; font-size: 0.9rem;">
                                                                Ver transacción
                                                            </a>
                                                            <i v-if="loadingTransaction" class="pi pi-spin pi-spinner" style="margin-left: 8px; font-size: 0.9rem; color: #f18700;"></i>
                                                        </div>
                                                        <!-- El historial de abonos sigue accesible aunque la compra ya quedó
                                                             PAGADA y aunque haya contabilidad automática (H57). -->
                                                        <div v-if="this.purchase.id !== null && hasPaymentHistory(this.purchase)" style="margin-top: 8px;">
                                                            <a @click="paymentHistoryDialog = true" style="cursor: pointer; color: #18407f; text-decoration: underline; font-size: 0.9rem;">
                                                                Ver abonos ({{ this.purchase.payments.length }})
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div style="margin-top: 10px;">
                                                        <div class="col-12 mb-2 lg:col-12 lg:mb-0" v-if="(this.business.makesRetention === true && this.purchase.rentPercentage !== null && this.purchase.ivaPercentage !== null)">
                                                            <h5 style="margin: 5px 0px;">Valores a retener</h5>
                                                            <h6 style="margin: 0px; font-weight: 300;">Renta: ${{ this.purchase.rentRetentionValue.toFixed(2) }}</h6>
                                                            <h6 style="margin: 0px; font-weight: 300;">IVA: ${{ this.purchase.ivaRetentionValue.toFixed(2) }}</h6>
                                                            <h6 style="margin: 0px; font-weight: 300;">Total: ${{ this.purchase.rentRetentionValue.plus(this.purchase.ivaRetentionValue).toFixed(2) }}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="field col-12 md:col-6 saleInformationContainer">
                                                    <div style="display: flex;">
                                                        <label class="SaleInformationLabel">Subtotal 0%</label>
                                                        <InputText v-if="!this.purchase.hasXMLLoaded && this.purchase.items.length == 0" v-model="this.purchase.sub0" type="number" class="number-textfield" autofocus :disabled="this.purchase.id !== null" @change="onSub0Changed"/>
                                                        <InputText v-else :value="this.purchase.sub0.toFixed(2)" type="number" class="number-textfield" autofocus :disabled="true"/>
                                                    </div>
                                                    <div style="display: flex;">
                                                        <label class="SaleInformationLabel">Subtotal 5%</label>
                                                        <InputText v-if="!this.purchase.hasXMLLoaded && this.purchase.items.length == 0" v-model="this.purchase.sub5" type="number" class="number-textfield" autofocus :disabled="this.purchase.id !== null" @change="onSub5Changed"/>
                                                        <InputText v-else :value="this.purchase.sub5.toFixed(2)" type="number" class="number-textfield" autofocus :disabled="true"/>
                                                    </div>
                                                    <div style="display: flex;">
                                                        <label class="SaleInformationLabel">Subtotal {{ this.business.taxPercentage }}%</label>
                                                        <InputText v-if="!this.purchase.hasXMLLoaded && this.purchase.items.length == 0" v-model="this.purchase.sub15" type="number" class="number-textfield" autofocus :disabled="this.purchase.id !== null" @change="onSub15Changed"/>
                                                        <InputText v-else :value="this.purchase.sub15.toFixed(2)" type="number" class="number-textfield" autofocus :disabled="true"/>
                                                    </div>
                                                    <div style="display: flex;">
                                                        <label class="SaleInformationLabel">Subtotal sin imp.</label>
                                                        <InputText :value="this.purchase.subtotal.toFixed(2)" type="number" class="number-textfield" autofocus :disabled="true"/>
                                                    </div>
                                                    <div style="display: flex;">
                                                        <label class="SaleInformationLabel">ICE</label>
                                                        <InputText v-if="!this.purchase.hasXMLLoaded && this.purchase.items.length == 0" v-model="this.purchase.iceValue" type="number" class="number-textfield" autofocus :disabled="this.purchase.id !== null" @change="onIceChanged"/>
                                                        <InputText v-else :value="this.purchase.iceValue.toFixed(2)" type="number" class="number-textfield" autofocus :disabled="true"/>
                                                    </div>
                                                    <div style="display: flex;">
                                                        <label class="SaleInformationLabel">IVA</label>
                                                        <InputText :value="this.purchase.tax.toFixed(2)" type="number" class="number-textfield" autofocus :disabled="true"/>
                                                    </div>
                                                    <div style="display: flex;">
                                                        <label class="SaleInformationLabel">Descuento</label>
                                                        <InputText v-if="!this.purchase.hasXMLLoaded && this.purchase.items.length == 0" v-model="this.purchase.discount" type="number" class="number-textfield" autofocus :disabled="this.purchase.id !== null" @change="onTotalDiscountChanged"/>
                                                        <InputText v-else :value="this.purchase.discount.toFixed(2)" type="number" class="number-textfield" autofocus :disabled="true"/>
                                                    </div>
                                                    <div style="display: flex;">
                                                        <label class="SaleInformationLabel">Total</label>
                                                        <InputText v-if="!this.purchase.hasXMLLoaded && this.purchase.items.length == 0" v-model="this.purchase.total" type="number" class="number-textfield" autofocus :disabled="this.purchase.id !== null" @change="onTotalChanged"/>
                                                        <InputText v-else :value="this.purchase.total.toFixed(2)" type="number" class="number-textfield" autofocus :disabled="true"/>
                                                    </div>
                                                    <div v-if="this.purchase.hasPartialPayments" style="display: flex; margin-top: 8px; padding-top: 8px; border-top: 1px dashed #ccc;">
                                                        <label class="SaleInformationLabel" style="color: #10b981;">Abonado</label>
                                                        <label style="margin: 0px 0px 0px auto; color: #10b981;">{{ this.purchase.paidAmount.toFixed(2) }}</label>
                                                    </div>
                                                    <div v-if="this.purchase.hasPartialPayments" style="display: flex;">
                                                        <label class="SaleInformationLabel" style="color: #f59e0b;"><b>Saldo pendiente</b></label>
                                                        <label style="margin: 0px 0px 0px auto; color: #f59e0b;"><b>{{ this.purchase.pendingAmount !== null ? this.purchase.pendingAmount.toFixed(2) : this.purchase.total.minus(this.purchase.paidAmount).toFixed(2) }}</b></label>
                                                    </div>
                                                </div>
                                                <div class="field col-12 md:col-12" style="text-align: right;" v-show="this.purchase.edoc === null">
                                                    <label v-show="this.business.makesRetention && this.purchase.id === null && this.purchase.vendorIdentification !== null" style="font-style: italic;">El <b>comprobante de retención</b> se generará automaticamente</label>
                                                    <label v-show="this.purchase.id !== null && this.purchase.edoc !== null" style="font-style: italic;">El <b>comprobante de retención</b> se ha generado automaticamente, descárguelo aquí</label>
                                                </div>
                                                <div class="field col-12 md:col-12 saleFormButtonContainer" v-show="this.purchase.edoc === null">
                                                    <Button label="Limpiar" v-show="showClearButton" class="p-button-raised p-button-danger mr-2 mb-2" style="max-width: 220px;" @click="clearPurchase"/>
                                                    <Button label="Anular" v-show="showDeleteButton" class="p-button-raised p-button-danger mr-2 mb-2" style="max-width: 220px;" @click="displayDeletePurchaseConfirmation(true)"/>
                                                    <div style="margin-left: auto;"></div>
                                                    <Button label="Guardar" v-show="showSaveButton" :loading="loadingSaveButton" class="p-button-raised p-button-success mr-2 mb-2" style="max-width: 220px;" @click="savePurchase()"/>
                                                    <Button label="Generar Retención" v-show="showCreateRetentionButton" :loading="loadingCreateRetentionButton" class="p-button-raised p-button-success mr-2 mb-2" style="max-width: 220px;" @click="attemptToCreateRetention()"/>
                                                    <Menu ref="menu" :model="downloadOptions" :popup="true" style="width: auto; max-width: 170px;">
                                                        <template #item="{item}">
                                                            <Button type="button" :label="item.label" :icon="item.icon" class="menuButton mr-2 mb-2" :loading="loadingDownloadRentetionButton" @click="downloadPurchase(item.name)"/>
                                                        </template>
                                                    </Menu>
                                                    <Button type="button" label="Descargar" icon="pi pi-angle-down" v-show="this.purchase.id !== null && this.purchase.edoc !== null" class="p-button-raised p-button-success mr-2 mb-2 download-button" @click="toggleDownloadMenu"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="grid formgrid" v-show="this.purchase.edoc !== null">
                                    <div class="col-12">
                                        <div class="card">
                                            <h5><b>Valores de Comprobante de Retención</b></h5>
                                            <div class="field col-12 md:col-6">
                                                <div style="margin-top: 10px;">
                                                    <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                                        <label style="margin: 0px;"><b>Secuencial</b></label><br>
                                                        <label style="margin: 0px; font-weight: 300;">{{ (this.purchase.edoc !== null) ? this.purchase.edoc.sequence : "-" }}</label>
                                                    </div>
                                                    <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                                        <label style="margin: 0px;"><b>Fecha Emisión</b></label><br>
                                                        <label style="margin: 0px; font-weight: 300;">{{ (this.purchase.edoc !== null && this.purchase.edoc.sentAt !== null) ? this.purchase.edoc.sentAt.toLocaleDateString("es-ES") : "-" }}</label>
                                                    </div>
                                                    <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                                        <label style="margin: 0px;"><b>Fecha Autorización</b></label><br>
                                                        <label style="margin: 0px; font-weight: 300;">{{ (this.purchase.edoc !== null && this.purchase.edoc.authorizedAt !== null) ? this.purchase.edoc.authorizedAt.toLocaleDateString("es-ES") : "-" }}</label>
                                                    </div>
                                                    <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                                        <label style="margin: 0px;"><b>Código de acceso</b></label><br>
                                                        <label style="margin: 0px; font-weight: 300; max-width: 90%;">{{ (this.purchase.edoc !== null) ? this.purchase.edoc.accessCode : "-" }}</label>
                                                    </div>
                                                    <!-- Sin correo del proveedor la retención no se envió (H48). -->
                                                    <div class="col-12 mb-2 lg:col-12 lg:mb-0" v-if="this.purchase.retentionEmailNotice">
                                                        <small style="color: var(--orange-700);"><i class="pi pi-envelope mr-1"></i>{{ this.purchase.retentionEmailNotice }}</small>
                                                    </div>
                                                    <!-- Desenlace de la anulacion, no un cartel fijo: el texto y el color
                                                         salen de annulmentStatus (ver models/edocument.js). Antes decia
                                                         siempre "debe ser anulada en el portal del SRI" con solo mirar
                                                         nulled+received, y eso mentia justo cuando el SRI aceptaba la
                                                         solicitud. Lo que esta EN CURSO no sale aca. -->
                                                    <div class="col-12 mb-2 lg:col-12 lg:mb-0" v-if="this.purchase.edoc !== null && this.purchase.edoc.annulmentNotice !== null">
                                                    <div class="flex align-items-start mt-3 p-3"
                                                         :style="`background-color: var(--${this.purchase.edoc.annulmentNotice.color}-50); border-left: 4px solid var(--${this.purchase.edoc.annulmentNotice.color}-500); border-radius: 4px; --notice-accent: var(--${this.purchase.edoc.annulmentNotice.color}-500); --notice-accent-strong: var(--${this.purchase.edoc.annulmentNotice.color}-700);`">
                                                        <i class="pi mr-2 mt-1" :class="this.purchase.edoc.annulmentNotice.icon"
                                                           :style="`color: var(--${this.purchase.edoc.annulmentNotice.color}-700)`" />
                                                        <div style="flex: 1; min-width: 0;">
                                                            <div style="font-size: 0.9rem;">{{ this.purchase.edoc.annulmentNotice.title }}</div>
                                                            <div v-if="this.purchase.edoc.annulmentNotice.detail"
                                                                 style="font-size: 0.82rem; color: var(--text-color-secondary); margin-top: 0.15rem;">{{ this.purchase.edoc.annulmentNotice.detail }}</div>
                                                            <Button v-if="this.purchase.edoc.annulmentNotice.action"
                                                                    :label="this.purchase.edoc.annulmentNotice.action.label"
                                                                    :icon="this.purchase.edoc.annulmentNotice.action.icon"
                                                                    class="p-button-sm annulmentNoticeAction mt-2"
                                                                    :disabled="annulmentInProgress"
                                                                    @click="onAnnulmentAction(this.purchase.edoc.annulmentNotice.action.name)" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                            <div class="field col-12 md:col-12" style="text-align: right;" v-show="this.purchase.edoc !== null && this.purchase.edoc.nulled === false">
                                                <label v-show="this.business.makesRetention && this.purchase.id === null && this.purchase.vendorIdentification !== null" style="font-style: italic;">El <b>comprobante de retención</b> se generará automaticamente</label>
                                                <label v-show="this.purchase.id !== null && this.purchase.edoc !== null" style="font-style: italic;">El <b>comprobante de retención</b> se ha generado automaticamente, descárguelo aquí</label>
                                            </div>
                                            <div class="field col-12 md:col-12 saleFormButtonContainer" v-show="this.purchase.edoc !== null && this.purchase.edoc.nulled === false">
                                                <Button label="Limpiar" v-show="showClearButton" class="p-button-raised p-button-danger mr-2 mb-2" style="max-width: 220px;" @click="clearPurchase"/>
                                                <Button label="Anular" v-show="showDeleteButton" class="p-button-raised p-button-danger mr-2 mb-2" style="max-width: 220px;" @click="displayDeletePurchaseConfirmation(true)"/>
                                                <div style="margin-left: auto;"></div>
                                                <Button label="Guardar" v-show="showSaveButton" :loading="loadingSaveButton" class="p-button-raised p-button-success mr-2 mb-2" style="max-width: 220px;" @click="savePurchase()"/>
                                                <Menu ref="menu" :model="downloadOptions" :popup="true" style="width: auto; max-width: 170px;">
                                                    <template #item="{item}">
                                                        <Button type="button" :label="item.label" :icon="item.icon" class="menuButton mr-2 mb-2" :loading="loadingDownloadRentetionButton" @click="downloadPurchase(item.name)"/>
                                                    </template>
                                                </Menu>
                                                <Button type="button" label="Descargar" icon="pi pi-angle-down" v-show="this.purchase.id !== null && this.purchase.edoc !== null" class="p-button-raised p-button-success mr-2 mb-2 download-button" @click="toggleDownloadMenu"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <Dialog header="Advertencia" v-model:visible="subscriptionDialog" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
                                    <p class="line-height-3 m-0">
                                        {{ this.error.title }}<br>
                                        {{ this.error.mensaje }}<br>
                                        {{ this.error.informacionAdicional }}
                                    </p>
                                    <template #footer>
                                        <Button label="Cerrar" @click="closeSubscriptionDialog" class="p-button-secondary mr-2 mb-2"/>
                                        <Button label="Ver suscripción" @click="redirectToSubscription" class="p-button-info mr-2 mb-2"/>
                                    </template>
                                </Dialog>

                                <AccountEntry :data="this.purchase" :isVisible="this.accountEntryDialog" :mode="this.accountEntryMode" transactionType="purchase" @onSave="this.onSaveAccountEntry" @onCancel="this.onCancelAccountEntry"/>

                                <PaymentHistoryDialog :payments="this.purchase.payments" :isVisible="this.paymentHistoryDialog" @onClose="paymentHistoryDialog = false"/>

                                <Dialog header="Detalles de Transacciones" v-model:visible="transactionDialog" :breakpoints="{'960px': '90vw'}" :style="{width: '600px', 'background-color': '#ffffff'}" :modal="true" class="transaction-dialog">
                                    <div v-if="transactionData && transactionData.length > 0" style="padding: 0.5rem;">
                                        <!-- Resumen Total -->
                                        <div class="transaction-card" style="background: linear-gradient(135deg, #18407f 0%, #27285c 100%); color: white; padding: 1.5rem; border-radius: 12px; margin-bottom: 1rem; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
                                            <div style="display: flex; align-items: center; margin-bottom: 0.75rem;">
                                                <i class="pi pi-receipt" style="font-size: 1.5rem; margin-right: 0.75rem;"></i>
                                                <span style="font-size: 0.9rem; opacity: 0.9;">Resumen de Pagos</span>
                                            </div>
                                            <div>
                                                <div style="font-size: 0.85rem; opacity: 0.9; margin-bottom: 0.25rem;">Total Pagado</div>
                                                <div style="font-size: 1.5rem; font-weight: 700;">${{ calculateTotalAmount() }}</div>
                                            </div>
                                            <div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid rgba(255,255,255,0.2); text-align: center;">
                                                <span style="font-size: 0.85rem; opacity: 0.9;">{{ transactionData.length }} {{ transactionData.length === 1 ? 'Transacción' : 'Transacciones' }}</span>
                                            </div>
                                        </div>

                                        <!-- Lista de Transacciones -->
                                        <div style="max-height: 450px; overflow-y: auto; padding-right: 0.25rem;">
                                            <div v-for="(transaction, index) in transactionData" :key="index" class="transaction-card" style="background: white; padding: 1.25rem; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); margin-bottom: 1rem; border: 2px solid #eeedef;">
                                                <!-- Header de transacción -->
                                                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem; padding-bottom: 0.75rem; border-bottom: 2px solid #eeedef;">
                                                    <div style="display: flex; align-items: center; min-width: 0;">
                                                        <i :class="paymentMethodIcon(transaction.paymentMethod)" style="font-size: 1.2rem; margin-right: 0.5rem; color: #18407f;"></i>
                                                        <div style="min-width: 0;">
                                                            <div style="font-weight: 600; color: #27285c; font-size: 1rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                                                {{ transaction.account && transaction.account.name ? transaction.account.name : 'Cuenta' }}
                                                            </div>
                                                            <div style="font-size: 0.75rem; color: #6b7280;">
                                                                {{ paymentMethodLabel(transaction.paymentMethod) }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span style="background: #18407f; color: white; padding: 0.25rem 0.75rem; border-radius: 12px; font-size: 0.75rem; font-weight: 600;">
                                                        #{{ index + 1 }}
                                                    </span>
                                                </div>

                                                <!-- Monto -->
                                                <div style="margin-bottom: 1rem;">
                                                    <div style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase; letter-spacing: 0.5px;">Monto</div>
                                                    <div style="font-size: 1.4rem; font-weight: 700; color: #f18700;">
                                                        ${{ formatTransactionAmount(transaction.amount) }}
                                                    </div>
                                                </div>

                                                <!-- Metadata clave en filas (label : value) -->
                                                <div style="display: flex; flex-direction: column; gap: 0.4rem; font-size: 0.85rem;">
                                                    <div v-if="transaction.reference" style="display: flex; gap: 0.5rem;">
                                                        <i class="pi pi-bookmark" style="color: #6b7280; font-size: 0.9rem; margin-top: 2px;"></i>
                                                        <span style="color: #6b7280; min-width: 110px;">Referencia:</span>
                                                        <span style="color: #27285c; font-weight: 500; word-break: break-word;">{{ transaction.reference }}</span>
                                                    </div>
                                                    <div v-if="transaction.approvalNumber" style="display: flex; gap: 0.5rem;">
                                                        <i class="pi pi-check-circle" style="color: #16a34a; font-size: 0.9rem; margin-top: 2px;"></i>
                                                        <span style="color: #6b7280; min-width: 110px;">N° Aprobación:</span>
                                                        <span style="color: #27285c; font-weight: 600;">{{ transaction.approvalNumber }}</span>
                                                    </div>
                                                    <div v-if="transaction.account && transaction.account.bank" style="display: flex; gap: 0.5rem;">
                                                        <i class="pi pi-building" style="color: #6b7280; font-size: 0.9rem; margin-top: 2px;"></i>
                                                        <span style="color: #6b7280; min-width: 110px;">{{ transaction.account.moneyType === 'CARD' ? 'Pasarela:' : 'Banco:' }}</span>
                                                        <span style="color: #27285c; font-weight: 500;">{{ transaction.account.bank.name }}</span>
                                                    </div>
                                                    <div v-if="transaction.account && transaction.account.accountNumber" style="display: flex; gap: 0.5rem;">
                                                        <i class="pi pi-credit-card" style="color: #6b7280; font-size: 0.9rem; margin-top: 2px;"></i>
                                                        <span style="color: #6b7280; min-width: 110px;">N° Cuenta:</span>
                                                        <span style="color: #27285c; font-weight: 500;">{{ transaction.account.accountNumber }}</span>
                                                        <span v-if="transaction.account.accountType" style="color: #6b7280;">· {{ accountTypeLabel(transaction.account.accountType) }}</span>
                                                    </div>
                                                    <div v-if="transaction.createdAt" style="display: flex; gap: 0.5rem;">
                                                        <i class="pi pi-clock" style="color: #6b7280; font-size: 0.9rem; margin-top: 2px;"></i>
                                                        <span style="color: #6b7280; min-width: 110px;">Registrado:</span>
                                                        <span style="color: #27285c;">{{ formatTransactionDate(transaction.createdAt) }}</span>
                                                    </div>
                                                    <div v-if="transaction.creator" style="display: flex; gap: 0.5rem;">
                                                        <i class="pi pi-user" style="color: #6b7280; font-size: 0.9rem; margin-top: 2px;"></i>
                                                        <span style="color: #6b7280; min-width: 110px;">Operador:</span>
                                                        <span style="color: #27285c;">{{ transaction.creator }}</span>
                                                    </div>
                                                </div>

                                                <!-- Comprobante -->
                                                <div v-if="transaction.proof" style="margin-top: 1rem; padding-top: 0.75rem; border-top: 1px dashed #eeedef;">
                                                    <div style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 0.5rem;">
                                                        <i class="pi pi-paperclip" style="font-size: 0.8rem; margin-right: 0.25rem;"></i>
                                                        Comprobante adjunto
                                                    </div>
                                                    <div v-if="isImageProof(transaction.proof)" style="position: relative; cursor: zoom-in;" @click="openProof(transaction.proof)">
                                                        <img :src="resolveProofUrl(transaction.proof)" alt="Comprobante" style="width: 100%; max-height: 220px; object-fit: contain; border-radius: 8px; background: #f8f9fa; border: 1px solid #eeedef;" />
                                                        <div style="position: absolute; top: 0.5rem; right: 0.5rem; background: rgba(0,0,0,0.55); color: white; padding: 0.2rem 0.5rem; border-radius: 6px; font-size: 0.7rem;">
                                                            <i class="pi pi-search-plus" style="font-size: 0.7rem; margin-right: 0.25rem;"></i>Ampliar
                                                        </div>
                                                    </div>
                                                    <Button
                                                        v-else
                                                        label="Abrir comprobante"
                                                        icon="pi pi-external-link"
                                                        @click="openProof(transaction.proof)"
                                                        class="p-button-raised p-button-sm"
                                                        style="width: 100%; justify-content: center; padding: 0.5rem; font-weight: 600; font-size: 0.85rem; background: #18407f; border-color: #18407f;"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <template #footer>
                                        <Button label="Cerrar" @click="transactionDialog = false" class="p-button-secondary" style="width: 100%;"/>
                                    </template>
                                </Dialog>

                                <Dialog header="Sin transacción" v-model:visible="noTransactionDialog" :style="{width: '350px'}" :modal="true">
                                    <div class="flex align-items-center justify-content-center">
                                        <i class="pi pi-info-circle mr-3" style="font-size: 2rem; color: #18407f;" />
                                        <span>No se encontró una transacción adjuntada a esta compra.</span>
                                    </div>
                                    <template #footer>
                                        <Button label="Entendido" @click="noTransactionDialog = false" class="p-button-primary mr-2 mb-2" autofocus />
                                    </template>
                                </Dialog>

                                <!-- Mismo aviso en dos momentos (ver saleForm.vue): al ANULAR se
                                     ofrece anular sin reportar; al REPORTAR una anulacion que ya
                                     quedo solo aca ('unreported') el unico camino es cargar las
                                     credenciales, porque volver a anular revertiria todo otra vez. -->
                                <Dialog header="Credenciales del SRI no registradas" v-model:visible="showSriCredentialsDialog" :style="{width: '520px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                                    <div class="flex align-items-start">
                                        <i class="pi pi-info-circle mr-3 mt-1" style="font-size: 2rem; color: var(--blue-500)" />
                                        <div v-if="annulmentUnreported">
                                            <p class="mb-2">
                                                Esta compra ya está anulada en Contablus, pero
                                                <strong>para el SRI la retención sigue vigente</strong>.
                                            </p>
                                            <p class="mb-0">
                                                Registra las credenciales del portal <strong>SRI en línea</strong>
                                                y Contablus se encargará de informar la anulación y de dar
                                                seguimiento al estado de la solicitud.
                                            </p>
                                            <p v-if="!canEditBusiness" class="mt-2 mb-0" style="font-size: 0.85rem; color: var(--text-color-secondary);">
                                                Pídele a un administrador que las registre en Negocio.
                                            </p>
                                        </div>
                                        <div v-else>
                                            <p class="mb-2">
                                                Para anular el comprobante ante el SRI de forma
                                                automática, el negocio necesita tener registradas sus
                                                credenciales del portal <strong>SRI en línea</strong>.
                                            </p>
                                            <p class="mb-0" style="font-size: 0.9rem; color: var(--orange-700);">
                                                Si continúas sin reportar, la compra quedará anulada en
                                                Contablus pero <strong>para el SRI la retención seguirá
                                                vigente</strong>. Tendrás que anularla desde el portal.
                                            </p>
                                            <p v-if="!canEditBusiness" class="mt-2 mb-0" style="font-size: 0.85rem; color: var(--text-color-secondary);">
                                                Pídele a un administrador que las registre en Negocio.
                                            </p>
                                        </div>
                                    </div>
                                    <template #footer>
                                        <Button :label="(annulmentUnreported && !canEditBusiness) ? 'Entendido' : 'Cancelar'" @click="showSriCredentialsDialog = false" class="p-button-secondary mr-2 mb-2"/>
                                        <Button v-if="!annulmentUnreported" label="Anular sin reportar" icon="pi pi-exclamation-triangle" @click="deletePurchase(false)" class="p-button-warning mr-2 mb-2"/>
                                        <Button v-if="canEditBusiness" label="Registrar credenciales" icon="pi pi-external-link" @click="goToSriCredentials" class="p-button-info mr-2 mb-2" autofocus/>
                                    </template>
                                </Dialog>

                                
                                <!-- Desenlace de la anulacion. Dialog y no toast: los tres mensajes son
                                     largos —el de "esperando al receptor" tiene que explicar que el
                                     comprobante SIGUE VALIDO y hasta que fecha— y se desbordaban de la
                                     pantalla. Es la comunicacion que cierra el flujo: el usuario tiene
                                     que leerla, no alcanzarla de reojo antes de que se desvanezca. -->
                                <Dialog :header="annulmentOutcome ? annulmentOutcome.title : ''"
                                        v-model:visible="showAnnulmentOutcome"
                                        :style="{width: '460px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                                    <div v-if="annulmentOutcome !== null" class="flex align-items-start">
                                        <i class="pi mr-3" :class="annulmentOutcome.icon"
                                           :style="`font-size: 2rem; color: var(--${annulmentOutcome.color}-500)`" />
                                        <!-- La clave de acceso son 49 digitos sin espacios: una "palabra" que el
                                             navegador no parte sola. `overflow-wrap: anywhere` la deja
                                             cortar, y `min-width: 0` es imprescindible porque como hijo
                                             de un flex su min-width:auto le impide encoger por debajo
                                             del ancho de su contenido. -->
                                        <div style="min-width: 0;">
                                            <span style="line-height: 1.5; overflow-wrap: anywhere;">{{ annulmentOutcome.message }}</span>
                                            <p v-if="annulmentOutcome.action === 'sriCredentials' && !canEditBusiness" class="mt-2 mb-0" style="font-size: 0.85rem; color: var(--text-color-secondary);">
                                                Pídele a un administrador que las registre en Negocio.
                                            </p>
                                        </div>
                                    </div>
                                    <template #footer>
                                        <Button label="Entendido" @click="showAnnulmentOutcome = false"
                                                class="p-button-secondary mr-2 mb-2" autofocus />
                                        <!-- Sin credenciales la consulta inmediata no existe: el atajo lleva a
                                             cargarlas. El backend marca el motivo (reason), no se adivina. -->
                                        <Button v-if="annulmentOutcome !== null && annulmentOutcome.action === 'sriCredentials' && canEditBusiness"
                                                label="Ir a Negocio" icon="pi pi-external-link" @click="goToSriCredentials"
                                                class="p-button-info mr-2 mb-2" />
                                    </template>
                                </Dialog>
                                <Dialog :header="purchaseAnnulmentExpired ? 'No se puede anular' : 'Confirmación'" v-model:visible="showDeletePurchaseConfirmation" :style="{width: purchaseAnnulmentExpired ? '480px' : '420px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                                    <!-- Fuera del plazo del SRI no se anula: el mensaje (y la guarda que lo
                                         respalda) vienen del backend, ver EDocument.annulmentWindowClosedMessage. -->
                                    <div v-if="purchase.edoc && purchase.edoc.annulmentExpired" class="flex align-items-start">
                                        <i class="pi pi-ban mr-3" style="font-size: 2rem; color: var(--red-500)" />
                                        <span>{{ purchase.edoc.annulmentExpiredMessage }}</span>
                                    </div>
                                    <template v-else>
                                        <div class="flex align-items-center justify-content-center">
                                            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                                            <span>¿Está seguro de anular esta compra?</span>
                                        </div>
                                        <!-- La retencion la tiene que aceptar el proveedor:
                                             decirlo antes evita la sorpresa de que el
                                             comprobante siga vigente despues de anular. -->
                                        <div v-if="purchase.edoc && purchase.edoc.authorized === true" class="mt-3 p-3"
                                             style="background-color: var(--blue-50); border-left: 4px solid var(--blue-500); border-radius: 4px; font-size: 0.9rem;">
                                            Se enviará la solicitud al SRI. El proveedor tendrá
                                            5 días hábiles para aceptarla; hasta entonces la
                                            retención sigue siendo válida.
                                        </div>
                                    </template>
                                    <template #footer>
                                        <Button v-if="purchaseAnnulmentExpired" label="Entendido" @click="displayDeletePurchaseConfirmation(false)" class="p-button-secondary mr-2 mb-2" autofocus/>
                                        <template v-else>
                                            <Button label="No" @click="displayDeletePurchaseConfirmation(false)" class="p-button-secondary mr-2 mb-2"/>
                                            <Button label="Sí" @click="deletePurchase" class="p-button-warning mr-2 mb-2" autofocus />
                                        </template>
                                    </template>
                                </Dialog>

                                <Dialog v-model:visible="productDialog" :style="{'max-width': '450px', width: '90%'}" header="Buscar Producto" :modal="true" class="p-fluid">
                                    <InputText ref="productSearchInput" type="text" autofocus @change="onProductFilterChanged" style="margin-top: 5px;"/>
                                    <DataTable :value="this.productOptions" v-model:selection="selectedProduct" selectionMode="single" @rowSelect="onProductSelected" :scrollable="true" scrollHeight="400px" scrollDirection="both" class="mt-3 editable-cells-table">
                                        <Column field="code" header="Cód." :style="{width: '30%','min-width':'50px'}"></Column>
                                        <Column field="name" header="Nombre." :style="{width: '50%','min-width':'100px'}"></Column>
                                        <Column field="stock" header="Stock" :style="{width: '20%','min-width':'100px'}">
                                            <template #body="slotProps">
                                                {{ (slotProps.data.stock !== undefined && slotProps.data.stock !== null) ? slotProps.data.stock : "-" }}
                                            </template>
                                        </Column>
                                    </DataTable>
                                    <template #footer>
                                        <Button label="Cerrar" class="p-button-secondary mr-2 mb-2" @click="hideProductDialog"/>
                                    </template>
                                </Dialog>
                            </div>
                        </div>
                    </div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>

import { saveDownload } from '../../service/fileDownload';
import { authorizedXmlNotice } from '../../service/authorizedXml';
import httpRequest from '../../service/httpRequest';
import Purchase, { OBSERVATIONS_MAX_LENGTH } from '../../models/purchase';
import PurchaseItem from '../../models/purchaseItem';
import Product from '../../models/product';
import ProductProvider from '../../models/productProvider';
import Business from '../../models/business';
import Big from 'big.js';
import AccountEntry from '../../components/Accounting/AccountEntry.vue';
import { rejectionDetail, isAlreadyCollected, alreadyCollectedToast } from '../../components/Accounting/accountEntryRules';
import PaymentHistoryDialog from '../../components/Accounting/PaymentHistoryDialog.vue';
import ObservationsField from '../../components/General/ObservationsField.vue';
import EventBus from '@/AppEventBus';
import { showSriPendingToast, clearSriPendingToast } from '@/service/sriPendingToast';
import { documentSavedDespiteReceiptError } from '@/service/receiptOutcome';
import { purchasePayload } from '@/models/purchasePayload';
import { hasPaymentHistory } from '@/service/paymentHistory';

export default {
	data() {
		return {
            business: new Business(),
            purchase: new Purchase(),
            cardBackgroundColor: "white",
            providers: [],
            productOptions: [],
            receiptItems: [],
            selectedProduct: null,
            productDialog: false,
            subscriptionDialog: false,
            establishmentCode: null,
            emitionPointCode: null,
            serialNumber: null,
            error: {},

            cellData: {},

            // Account Entry
            accountEntryDialog: false,
            accountEntryMode: 'simple', // 'simple' | 'multiple' | 'partial'
            paymentHistoryDialog: false,

            // Transaction viewer
            loadingTransaction: false,
            transactionDialog: false,
            transactionData: null,
            noTransactionDialog: false,
            pendingPurchase: null,

            // Show
            showNewButton: false,
            showClearButton: false,
            showSaveButton: false,
            showCreateRetentionButton: false,
            showDeleteButton: false,
            showDeletePurchaseConfirmation: false,

            // Loading
            loadingSaveButton: false,
            loadingCreateRetentionButton: false,
            loadingCollectButton: false,
            loadingDownloadRentetionButton: false,

            // Descarga de XML de compra desde el portal SRI (por clave de acceso)
            sriDialogVisible: false,
            sriAccessCode: '',
            sriDownloading: false,
            sriRequestId: null,
            sriTimeoutHandle: null,

            // Bloqueo por factura ya ingresada. La clave de acceso identifica
            // univocamente al comprobante, asi que se consulta contra el backend
            // al cargar un XML y antes de pedirle uno al portal del SRI.
            duplicateDialogVisible: false,
            duplicatePurchase: null,

            // Anular una compra con retención ya no es instantáneo: hay que
            // avisarle al SRI. Bloquea el botón mientras dura.
            annulmentInProgress: false,
            // Desenlace de la anulacion. Va en Dialog y no en toast: los mensajes
            // son largos (el de "esperando" explica el plazo y que el comprobante
            // sigue siendo valido) y se desbordaban de la pantalla. Ademas es
            // informacion que hay que leer, no que se pueda pasar de largo.
            showAnnulmentOutcome: false,
            annulmentOutcome: null,

            // Aviso cuando hay que anular una retención y el negocio no tiene
            // credenciales del portal del SRI cargadas.
            showSriCredentialsDialog: false,
            sriMessage: null,            // mensaje persistente anclado al popup
            sriMessageSeverity: 'error', // 'error' | 'warn' | 'info' | 'success'

            // Type of record
            recordTypes: [
                {name: 'Ingresar por factura', code: 'purchase'},
                {name: 'Ingresar con descripción', code: 'expense'},
            ],
            selectedRecord: {name: 'Ingresar por factura', code: 'purchase'},
            
            // Type of expense
            // Se carga de Contabilidad > Mapeos. Vacio = el modulo esta apagado o el
            // usuario todavia no mapeo ninguna categoria, y el campo no se muestra.
            expensesType: [],
            selectedExpenseType: null,

            // Tipo de gasto basico (Purchase.basicExpenseType). Espejo de
            // Purchase.BASIC_EXPENSE_TYPES en el backend, que valida el codigo.
            basicExpensesType: [
                { name: 'Viveres / Supermercado', code: 'viveres' },
                { name: 'Transporte / Combustible', code: 'transporte' },
                { name: 'Vivienda / Servicios Básicos', code: 'vivienda' },
                { name: 'Salud', code: 'salud' },
                { name: 'Educación', code: 'educacion' },
                { name: 'Entretenimiento / Ocio', code: 'entretenimiento' },
                { name: 'Restaurantes / Comida Rápida', code: 'restaurantes' },
                { name: 'Ropa / Calzado / Accesorios', code: 'ropa' },
                { name: 'Hogar / Muebles / Electrodomésticos', code: 'hogar' },
                { name: 'Otros', code: 'otros' }
            ],
            selectedBasicExpenseType: null,

            // Credit days options
            creditDays: [
                {name: '0 días', code: '0'},
                {name: '1 días', code: '1'},
                {name: '3 días', code: '3'},
                {name: '7 días', code: '7'},
                {name: '14 días', code: '14'},
                {name: '21 días', code: '21'},
                {name: '30 días', code: '30'},
                {name: '45 días', code: '45'},
                {name: '60 días', code: '60'},
                {name: '90 días', code: '90'},
            ],
            creditDay: {name: '0 días', code: '0'},

            // Download
            downloadOptions: [
                {
                    label: 'PDF',
                    name: 'pdf',
                    icon: 'pi pi-file-pdf'
                },
                {
                    label: 'XML',
                    name: 'xml',
                    icon: 'pi pi-file-excel'
                },
            ],
		}
	},
    async created() {
        window.scrollTo(0, 0);

        // Escuchar el XML de compra que llega por WebSocket (descarga del SRI)
        EventBus.on('purchase_xml_result', this.onSriXmlResult);
        EventBus.on('annulment_result', this.onAnnulmentResult);

        // Get business
        this.business = await this.$store.getters.business;

        // Categorias de egreso (Contabilidad > Mapeos). Va antes de cargar la compra
        // porque setupUI() resuelve contra esta lista.
        await this.loadExpenseCategories();

        // Get purchase data if exists
        let purchaseId = this.$route.query.id;
        if (purchaseId !== null && purchaseId !== undefined) {
            let response = await httpRequest.getPurchase(purchaseId);
            if (response.status == 200) {
                this.purchase = new Purchase(response.data);
                this.setupUI();

                if (this.purchase.receiptXML !== null) {
                    const xml = this.parseXMLFromString(this.purchase.receiptXML);
                    this.extractXMLData(xml);
                }

                // Setup duedate/creditdays dropdown
                this.creditDay = this.getCreditDayDic(this.purchase.creditDays);
                
                // Setup remaining values
                if (this.purchase.serialNumber !== undefined && this.purchase.serialNumber !== null) {
                    this.establishmentCode = this.purchase.serialNumber.substring(0,3);
                    this.emitionPointCode = this.purchase.serialNumber.substring(3,6);
                    this.serialNumber = this.purchase.serialNumber.substring(6);
                } else {
                    this.establishmentCode = "";
                    this.emitionPointCode = "";
                    this.serialNumber = "";
                }
            }
        } else { this.setupUI(); }
    },
    beforeUnmount() {
        EventBus.off('purchase_xml_result', this.onSriXmlResult);
        EventBus.off('annulment_result', this.onAnnulmentResult);
        if (this.sriTimeoutHandle) { clearTimeout(this.sriTimeoutHandle); this.sriTimeoutHandle = null; }
        clearSriPendingToast(this.$toast);
    },
    computed: {
        observationsMaxLength() {
            return OBSERVATIONS_MAX_LENGTH;
        },
        // Compra guardada: se muestra solo si trae tipo basico. Compra nueva: con el
        // setting prendido y sin categorias mapeadas en Contabilidad.
        showBasicExpenseType() {
            if (this.purchase.id !== null) return !!this.selectedBasicExpenseType;
            if (this.expensesType.length) return false;
            const user = this.$store.getters.getUser;
            const flag = user && user.settings && user.settings.settings && user.settings.settings.egreso_expenseType;
            return !!(flag && flag.value);
        },
        // Fecha de la compra que bloquea, para el aviso de duplicado.
        duplicatePurchaseDate() {
            if (!this.duplicatePurchase || !this.duplicatePurchase.createdAt) return '-';
            const date = new Date(this.duplicatePurchase.createdAt);
            if (isNaN(date.getTime())) return '-';
            return date.toLocaleDateString('es-EC', { year: 'numeric', month: 'numeric', day: 'numeric' });
        },
        // Sin credenciales del portal no se le puede informar la anulación al SRI.
        hasSriCredentials() {
            const business = this.$store.getters.business;
            return !!(business && business.hasSriPortalCredentials);
        },
        canEditBusiness() {
            return this.$can('business');
        },
        // La compra ya se anulo en Contablus sin avisarle al SRI. Decide que
        // variante muestra el aviso de credenciales.
        annulmentUnreported() {
            return !!(this.purchase && this.purchase.edoc && this.purchase.edoc.annulmentUnreported);
        },
        // Paso el plazo del SRI para anular la retencion (ver models/edocument.js).
        purchaseAnnulmentExpired() {
            return !!(this.purchase && this.purchase.edoc && this.purchase.edoc.annulmentExpired);
        },
        hasAccountability() {
            const user = this.$store.getters.getUser;
            const flag = user && user.settings && user.settings.settings && user.settings.settings.account_enableAutoTransactions;
            return !!(flag && flag.value);
        },
        paymentMethods() {
            const baseMethods = [
                {name: 'Efectivo', code: 'CASH'},
                {name: 'Transferencia', code: 'TRANSFER'},
                {name: 'Tarjeta Débito', code: 'DEBIT_CARD'},
                {name: 'Tarjeta Crédito', code: 'CREDIT_CARD'},
                {name: 'Cheque', code: 'CHECK'},
            ];
            
            // Solo agregar MIXTO si la contabilidad automática está activada
            const user = this.$store.getters.getUser;
            const hasAccountability = user && user.settings && user.settings.settings && user.settings.settings.account_enableAutoTransactions && user.settings.settings.account_enableAutoTransactions.value;
            if (hasAccountability === true) {
                baseMethods.push({name: 'Mixto', code: 'MIXED'});
            }
            
            return baseMethods;
        }
    },
	methods: {
        hasPaymentHistory,
        // ---- Bloqueo de factura ya ingresada --------------------------------
        // La clave de acceso del SRI identifica univocamente al comprobante, asi
        // que sirve de criterio de duplicado al ingresar una factura de compra.
        claveAccesoOf(xml) {
            const infoTributaria = xml.getElementsByTagName("infoTributaria")[0];
            if (!infoTributaria) return null;
            const node = infoTributaria.getElementsByTagName("claveAcceso")[0];
            return node ? node.textContent.trim() : null;
        },
        // Devuelve la compra ya registrada con esa clave, o null si se puede seguir.
        // Un fallo de red NO bloquea: el chequeo es una ayuda para no duplicar, no
        // un requisito para ingresar. Solo se frena cuando el backend lo confirma.
        async findRegisteredPurchase(accessCode) {
            const code = (accessCode || '').replace(/\D/g, '');
            if (code.length === 0) return null;

            const response = await httpRequest.checkPurchaseAccessCode(code);
            if (!response || response.status !== 200 || !response.data) return null;
            if (response.data.registered !== true) return null;

            return response.data.purchase || {};
        },
        showDuplicatePurchaseDialog(purchase) {
            this.duplicatePurchase = purchase;
            this.duplicateDialogVisible = true;
        },
        acknowledgeDuplicatePurchase() {
            this.duplicateDialogVisible = false;
            this.duplicatePurchase = null;
            this.clearPurchase();
            // El FileUpload basico sigue mostrando el nombre del XML rechazado
            // como etiqueta del boton; sin esto el formulario se ve limpio menos ahi.
            if (this.$refs.xmlUpload) { this.$refs.xmlUpload.clear(); }
        },

        // ---- Descarga de XML de compra desde el portal SRI ------------------
        openSriDownloadDialog() {
            this.sriAccessCode = '';
            this.sriDownloading = false;
            this.sriMessage = null;
            this.sriDialogVisible = true;
        },
        setSriMessage(severity, text) {
            this.sriMessageSeverity = severity;
            this.sriMessage = text;
        },
        async downloadFromSri() {
            if (this.sriDownloading) return;
            this.sriMessage = null;
            const code = (this.sriAccessCode || '').replace(/\D/g, '');
            if (code.length !== 49) {
                this.setSriMessage('warn', 'La clave de acceso debe tener 49 dígitos.');
                return;
            }

            // Guard de doble ingreso ANTES de consultar al SRI: si el WS no
            // responde, la descarga cae al portal, que toma el turno unico de
            // Chrome del servidor y puede tardar dos minutos, y no vale gastarlo
            // en una factura que ya esta registrada.
            const registered = await this.findRegisteredPurchase(code);
            if (registered) {
                this.sriDialogVisible = false;
                this.showDuplicatePurchaseDialog(registered);
                return;
            }

            // requestId para correlacionar la respuesta que llega por WebSocket
            this.sriRequestId = Date.now() + '-' + Math.random().toString(36).slice(2);
            this.sriDownloading = true;

            const response = await httpRequest.downloadPurchaseXML(code, this.sriRequestId);
            if (!response || response.status !== 200) {
                this.sriDownloading = false;
                const msg = (response && response.error) ? response.error : 'No se pudo iniciar la descarga.';
                this.setSriMessage('error', msg);
                return;
            }

            // Via normal: el backend lo trajo del WS del SRI y viene en la misma
            // respuesta. Solo si el WS no respondio se va al portal y el XML
            // llega despues por WebSocket.
            if (response.data && response.data.xml) {
                this.onSriXmlResult(Object.assign({}, response.data, { requestId: this.sriRequestId }));
                return;
            }

            // Salvaguarda: si el socket nunca responde, cortar el spinner.
            if (this.sriTimeoutHandle) clearTimeout(this.sriTimeoutHandle);
            this.sriTimeoutHandle = setTimeout(() => {
                if (this.sriDownloading) {
                    this.sriDownloading = false;
                    this.setSriMessage('warn', 'La descarga está tardando demasiado. Vuelve a intentarlo.');
                }
            }, 180000);
        },
        onSriXmlResult(data) {
            // Ignorar resultados de otros pedidos / otras pestañas.
            if (!data || data.requestId !== this.sriRequestId) return;
            if (this.sriTimeoutHandle) { clearTimeout(this.sriTimeoutHandle); this.sriTimeoutHandle = null; }
            this.sriDownloading = false;

            if (data.status !== 'ok' || !data.xml) {
                // Mensaje persistente anclado al popup (no toast), para que el
                // usuario lo lea con calma (p. ej. "no se encontró el comprobante").
                this.setSriMessage('error', data.message || 'No se pudo obtener el XML.');
                return;
            }

            try {
                // Mismo pipeline que "Cargar XML" (onXMLUploaded).
                const xml = this.parseXMLFromString(data.xml);
                this.extractXMLData(xml);
                this.purchase.receiptXML = data.xml;
                this.sriMessage = null;
                this.sriDialogVisible = false;
            } catch (error) {
                console.error('Error procesando XML del SRI:', error);
                this.setSriMessage('error', 'Error al procesar el XML: ' + error.message);
            }
        },
        async setupUI() {
            this.showNewButton = this.purchase.id !== null;
            this.showClearButton = this.purchase.id === null;
            this.showDeleteButton = this.purchase.id !== null;
            this.showSaveButton = this.purchase.id === null;
            this.showCreateRetentionButton = this.business.makesRetention && this.purchase.shouldCreateEDOC;
            this.cardBackgroundColor = (this.purchase.edoc !== null && this.purchase.edoc.nulled === true) ? "#ffc9c9" : "white";
            if (this.purchase.id === null) { this.selectedRecord = {name: 'Ingresar por factura', code: 'purchase'} }
            else { this.selectedRecord = (this.purchase.reportedWithReceipt) ? {name: 'Ingresar por factura', code: 'purchase'} : {name: 'Ingresar con descripción', code: 'expense'} }

            if (this.purchase.expenseType) {
                // Las compras anteriores guardan codigos que ya no se ofrecen. Se muestran
                // tal cual en vez de dejar el campo vacio; no se inventa una categoria.
                this.selectedExpenseType =
                    this.expensesType.find(expense => this.purchase.expenseType === expense.code)
                    || { name: this.purchase.expenseType, code: this.purchase.expenseType };
            }
            if (this.purchase.basicExpenseType) {
                this.selectedBasicExpenseType =
                    this.basicExpensesType.find(expense => this.purchase.basicExpenseType === expense.code)
                    || { name: this.purchase.basicExpenseType, code: this.purchase.basicExpenseType };
            }
        },

        async loadExpenseCategories() {
            // Un fallo aqui NO rompe el formulario: sin categorias el campo simplemente
            // no aparece, que es lo correcto si Contabilidad esta apagado o desinstalado.
            try {
                const response = await httpRequest.getPurchaseExpenseCategories();
                this.expensesType = (response.status === 200 && response.data)
                    ? (response.data.categories || []) : [];
            } catch (e) {
                this.expensesType = [];
            }
        },

        newPurchase() {
            let path = "/dashboard/compra/form"
            history.pushState(
                {},
                null,
                path
            )
            this.$router.go(path);
        }, 

        // Customer
        checkForm() {
            // Verificación de tipo de registro: PURCHASE (compra con factura)
            if (this.selectedRecord.code === 'purchase') {
                // Verificar nombre de proveedor
                if (this.purchase.vendorName == null || this.purchase.vendorName.length == 0) {
                    return "Ingrese el nombre del proveedor";
                }
                
                // Verificar identificación del proveedor
                if (this.purchase.vendorIdentification == null || this.purchase.vendorIdentification.length == 0) {
                    return "Ingrese la identificación del proveedor (CI/RUC)";
                }
                
                // Verificar número de serie de factura
                if (this.establishmentCode == null || this.establishmentCode.length == 0 ||
                    this.emitionPointCode == null || this.emitionPointCode.length == 0 ||
                    this.serialNumber == null || this.serialNumber.length == 0) {
                    return "Ingrese el número de serie completo de la factura (Establecimiento-Punto de Emisión-Secuencial)";
                }
                
                // Verificar fecha de emisión
                if (this.purchase.createdAt == null) {
                    return "Ingrese la fecha de emisión de la factura";
                }
                
                // Si la empresa hace retenciones, verificar porcentajes
                if (this.business.makesRetention === true) {
                    if (this.purchase.rentPercentage == null || this.purchase.ivaPercentage == null) {
                        return "Seleccione los porcentajes de retención para RENTA e IVA";
                    }
                }
            }
            
            // Verificación de tipo de registro: EXPENSE (gasto con descripción)
            if (this.selectedRecord.code === 'expense') {
                // Verificar que tenga descripción
                if (this.purchase.reason == null || this.purchase.reason.length == 0) {
                    return "Ingrese una descripción del gasto";
                }
                
                // Verificar fecha de creación
                if (this.purchase.createdAt == null) {
                    return "Ingrese la fecha del gasto";
                }
            }
            
            // Verificaciones comunes para ambos tipos
            // Verificar que el total sea mayor a cero
            if (this.purchase.total === null || this.purchase.total === undefined || this.purchase.total <= 0) {
                return "El total del egreso debe ser mayor a cero";
            }
            
            // Verificar que al menos uno de los valores (sub0, sub12) sea mayor a cero
            const sub0Value = this.purchase.sub0 ? parseFloat(this.purchase.sub0.toString()) : 0;
            const sub12Value = this.purchase.sub12 ? parseFloat(this.purchase.sub12.toString()) : 0;
            
            if (sub0Value <= 0 && sub12Value <= 0) {
                return "Debe ingresar al menos un valor en Subtotal 0% o Subtotal 12%";
            }
            
            return "";
        },
        onSerialNumberChanged() {
            if (this.establishmentCode !== null && this.emitionPointCode !== null && this.serialNumber !== null) {
                this.purchase.serialNumber = `${this.establishmentCode.toString().padStart(3, '0')}${this.emitionPointCode.toString().padStart(3, '0')}${this.serialNumber.toString().padStart(9, '0')}`;
            }
        },
    
        // Product
        showProductDialog() {
            this.productDialog = true;
        },
        hideProductDialog() {
            this.productDialog = false;
        },
        async onProductFilterChanged(event) {
            let filter = event.target.value;
            if (filter.length > 1) {
                const result = await httpRequest.getProducts(filter);
                if (result.status === 200) {
                    this.productOptions = result.data.map(product => new Product(product));
                } else { this.productOptions = [] }
            }
        },
        onProductSelected(event) {
            let product = new Product(event.data);
            let object = {
                productId: product.id,
                code: product.code,
                product: product.name,
                productObj: new Product(product),
                hasTax: product.hasTax,
                ivaCode: product.ivaCode,
                iceCode: product.iceCode,
                discount: 0.0,
                unitPrice: 0.0,
                totalPrice: 0.0,
            }
            
            let item = new PurchaseItem(object);
            this.purchase.addItem(item);
            
            this.selectedProduct = null;
            this.productDialog = false;
        },
        onAmountChanged(data) {
            let item = new PurchaseItem(data);
            this.purchase.addItem(item);
        },
        onUnitPriceChanged(data) {
            let item = new PurchaseItem(data);
            this.purchase.addItem(item);
        },
        onDiscountChanged(data) {
            data.discount = data.readableDiscount / 100;
            let item = new PurchaseItem(data);
            this.purchase.addItem(item);
        },
        onItemDeleted(item) {
            this.purchase.deleteItem(item.data);
        },

        // Purchase
        extractXMLData(xml) {
            try {
                // Limpiar items previos del XML
                this.receiptItems = [];
                
                let infoTributaria = xml.getElementsByTagName("infoTributaria")[0];
                let infoFactura = xml.getElementsByTagName("infoFactura")[0];

                if (!infoTributaria || !infoFactura) {
                    this.$toast.add({severity:'error', summary: 'Error', detail: 'El XML no tiene la estructura esperada', life: 5000});
                    return;
                }

                // Usar textContent en lugar de childNodes[0].nodeValue para manejar espacios en blanco
                
                // Obtener razón social
                let razonSocialElement = infoTributaria.getElementsByTagName("razonSocial")[0];
                let razonSocial = razonSocialElement ? razonSocialElement.textContent.trim() : "";
                
                // Obtener RUC
                let rucElement = infoTributaria.getElementsByTagName("ruc")[0];
                let ruc = rucElement ? rucElement.textContent.trim() : "";

                // Obtener serie de factura
                let estabElement = infoTributaria.getElementsByTagName("estab")[0];
                let estab = estabElement ? estabElement.textContent.trim() : "";
                
                let ptoEmiElement = infoTributaria.getElementsByTagName("ptoEmi")[0];
                let ptoEmi = ptoEmiElement ? ptoEmiElement.textContent.trim() : "";
                
                let secuencialElement = infoTributaria.getElementsByTagName("secuencial")[0];
                let secuencial = secuencialElement ? secuencialElement.textContent.trim() : "";

                // Obtener fecha de emisión
                let fechaEmisionElement = infoFactura.getElementsByTagName("fechaEmision")[0];
                if (fechaEmisionElement && fechaEmisionElement.textContent) {
                    let fechaEmision = fechaEmisionElement.textContent.trim();
                    const [day, month, year] = fechaEmision.split('/');
                    const now = new Date();
                    this.purchase.createdAt = new Date(year, month - 1, day, now.getHours(), now.getMinutes());
                }

                // Obtener clave de acceso
                let claveAccesoElement = infoTributaria.getElementsByTagName("claveAcceso")[0];
                let claveAcceso = claveAccesoElement ? claveAccesoElement.textContent.trim() : "";

                // Inicializar valores a 0 antes de procesarlos
                this.purchase.sub0 = new Big('0.0');
                this.purchase.sub12 = new Big('0.0');
                this.purchase.tax = new Big('0.0');

                let totalConImpuestosElement = infoFactura.getElementsByTagName("totalConImpuestos")[0];
                if (totalConImpuestosElement) {
                    let impuestos = totalConImpuestosElement.getElementsByTagName("totalImpuesto");
                    for (var i=0; i<impuestos.length;i++) {
                        // Check tax code
                        let taxCodeElement = impuestos[i].getElementsByTagName("codigoPorcentaje")[0];
                        if (!taxCodeElement || !taxCodeElement.textContent) continue;
                        
                        let taxCode = taxCodeElement.textContent.trim();
                        
                        let baseImponibleElement = impuestos[i].getElementsByTagName("baseImponible")[0];
                        let valorElement = impuestos[i].getElementsByTagName("valor")[0];
                        
                        if (!baseImponibleElement || !baseImponibleElement.textContent) continue;
                        if (!valorElement || !valorElement.textContent) continue;
                        
                        let baseImponible = new Big(baseImponibleElement.textContent.trim());
                        let valorImpuesto = new Big(valorElement.textContent.trim());
                        
                        // Códigos de IVA: "2"=12%, "3"=14%, "4"=15%, "5"=5%
                        if (taxCode === "2" || taxCode === "3" || taxCode === "4" || taxCode === "5") {
                            // SUMAR las bases imponibles y los valores de IVA (pueden haber múltiples tarifas)
                            this.purchase.sub12 = this.purchase.sub12.plus(baseImponible);
                            this.purchase.tax = this.purchase.tax.plus(valorImpuesto);
                        } else if (taxCode === "0" || taxCode === "6" || taxCode === "7") {
                            // Código "0" = 0%, "6" = No objeto de IVA, "7" = Exento de IVA
                            // SUMAR las bases imponibles sin IVA
                            this.purchase.sub0 = this.purchase.sub0.plus(baseImponible);
                        }
                    }
                }

                // Obtener descuento y total
                let totalDescuentoElement = infoFactura.getElementsByTagName("totalDescuento")[0];
                let totalDescuento = totalDescuentoElement && totalDescuentoElement.textContent ? 
                    new Big(totalDescuentoElement.textContent.trim()) : new Big('0.0');
                
                let importeTotalElement = infoFactura.getElementsByTagName("importeTotal")[0];
                let importeTotal = importeTotalElement && importeTotalElement.textContent ? 
                    new Big(importeTotalElement.textContent.trim()) : new Big('0.0');

                // Get products
                let detallesElement = xml.getElementsByTagName("detalles")[0];
                if (detallesElement) {
                    const detalles = detallesElement.getElementsByTagName("detalle");
                    for (i=0; i<detalles.length; i++) {
                        let impuestosElement = detalles[i].getElementsByTagName('impuestos')[0];
                        if (!impuestosElement) continue;
                        
                        let impuestos = impuestosElement.getElementsByTagName('impuesto');
                        var impuesto = false;
                        for (var j=0; j<impuestos.length; j++) {
                            let codigoPorcentajeElement = impuestos[j].getElementsByTagName('codigoPorcentaje')[0];
                            if (!codigoPorcentajeElement || !codigoPorcentajeElement.textContent) continue;
                            
                            let codigoPorcentaje = codigoPorcentajeElement.textContent.trim();
                            // Códigos de IVA: "2"=12%, "3"=14%, "4"=15%, "5"=5%
                            if (codigoPorcentaje === "2" || codigoPorcentaje === "3" || codigoPorcentaje === "4" || codigoPorcentaje === "5") { 
                                impuesto = true 
                            }
                        }

                        // Extraer datos del detalle usando textContent
                        let codigoPrincipalElement = detalles[i].getElementsByTagName('codigoPrincipal')[0];
                        let descripcionElement = detalles[i].getElementsByTagName('descripcion')[0];
                        let cantidadElement = detalles[i].getElementsByTagName('cantidad')[0];
                        let precioUnitarioElement = detalles[i].getElementsByTagName('precioUnitario')[0];
                        let descuentoElement = detalles[i].getElementsByTagName('descuento')[0];
                        let precioTotalSinImpuestoElement = detalles[i].getElementsByTagName('precioTotalSinImpuesto')[0];

                        if (codigoPrincipalElement && descripcionElement && cantidadElement && 
                            precioUnitarioElement && descuentoElement && precioTotalSinImpuestoElement) {
                            
                            this.receiptItems.push({
                                codigoPrincipal: codigoPrincipalElement.textContent.trim(),
                                descripcion: descripcionElement.textContent.trim(),
                                cantidad: new Big(cantidadElement.textContent.trim() || "0"),
                                precioUnitario: new Big(precioUnitarioElement.textContent.trim() || "0"),
                                descuento: new Big(descuentoElement.textContent.trim() || "0"),
                                precioTotalSinImpuesto: new Big(precioTotalSinImpuestoElement.textContent.trim() || "0"),
                                impuesto: impuesto
                            });
                        }
                    }
                    // Enable datatable
                    if (detalles.length > 0) { this.purchase.receiptXMLUrl = "" }
                }

                this.purchase.vendorName = razonSocial;
                this.purchase.vendorIdentification = ruc;
                this.establishmentCode = estab;
                this.emitionPointCode = ptoEmi;
                this.serialNumber = secuencial;
                this.purchase.serialNumber = `${estab}${ptoEmi}${secuencial}`;
                this.purchase.accessCode = claveAcceso;
                
                this.purchase.discount = totalDescuento;
                this.purchase.total = importeTotal;

                // Forzar actualización de la vista
                this.$forceUpdate();
                
                this.$toast.add({severity:'success', summary: 'Éxito', detail: 'XML cargado correctamente', life: 3000});
            } catch (error) {
                console.error('Error procesando XML:', error);
                this.$toast.add({severity:'error', summary: 'Error', detail: 'Error al procesar el XML: ' + error.message, life: 5000});
            }
        },
        onXMLUploaded(event) {
            const file = event.files[0];
            const reader = new FileReader();
            const self = this;
            reader.onload = async function(e) {
                const fileContent = e.target.result;

                let xml = null;
                try {
                    xml = self.parseXMLFromString(fileContent);
                } catch (error) {
                    // El handler es async: un throw suelto aqui seria una promesa
                    // rechazada que nadie ve, y el usuario se quedaria sin aviso.
                    console.error('Error procesando XML:', error);
                    self.$toast.add({severity:'error', summary: 'Error', detail: 'Error al procesar el XML: ' + error.message, life: 5000});
                    return;
                }

                // Antes de volcar nada al formulario: si la factura ya esta
                // registrada se bloquea, para no ingresarla dos veces.
                const registered = await self.findRegisteredPurchase(self.claveAccesoOf(xml));
                if (registered) {
                    self.showDuplicatePurchaseDialog(registered);
                    return;
                }

                self.extractXMLData(xml);
                self.purchase.receiptXML = fileContent;
            };
            reader.readAsText(file);
        },
        parseXMLFromString(xmlStr) {
            const parser = new DOMParser();
            var xml = parser.parseFromString(xmlStr, "text/xml");

            // Verificar si hubo errores de parseo
            const parserError = xml.getElementsByTagName("parsererror");
            if (parserError.length > 0) {
                throw new Error('Error al parsear XML: ' + parserError[0].textContent);
            }
            
            // Check the structure
            if (xml.documentElement.getElementsByTagName("comprobante").length == 1) {
                let comprobanteElement = xml.documentElement.getElementsByTagName("comprobante")[0];
                
                // Buscar el nodo de texto o CDATA que contiene el XML interno
                let comprobante = null;
                for (let i = 0; i < comprobanteElement.childNodes.length; i++) {
                    const node = comprobanteElement.childNodes[i];
                    if (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.CDATA_SECTION_NODE) {
                        const content = node.nodeValue.trim();
                        if (content.length > 0) {
                            comprobante = content;
                            break;
                        }
                    }
                }
                
                if (!comprobante) {
                    throw new Error('No se pudo extraer el contenido del elemento comprobante');
                }
                
                xml = parser.parseFromString(comprobante, "text/xml");
                
                // Verificar errores en el segundo parseo
                const parserError2 = xml.getElementsByTagName("parsererror");
                if (parserError2.length > 0) {
                    throw new Error('Error al parsear comprobante: ' + parserError2[0].textContent);
                }
            }

            return xml
        },
        formatUnitPrice(price) {
            if (!price) return '0.00';
            // Convierte a string y separa decimales
            const str = price.toString();
            if (!str.includes('.')) return price.toFixed(2);
            const decimals = str.split('.')[1];
            // Si los últimos dos decimales no son ceros, muestra 4
            if (decimals.length > 2 && !/^0{2}$/.test(decimals.slice(-2))) {
                // Elimina ceros no significativos al final
                return parseFloat(price.toFixed(4)).toString();
            }
            // Si los últimos dos decimales son ceros, muestra solo 2
            return price.toFixed(2);
        },
        toggleDownloadMenu(event) {
            this.$refs.menu.toggle(event);
        },
        onSub0Changed(event) {
            // No permitir cambios si hay XML cargado
            if (this.purchase.hasXMLLoaded) {
                return;
            }
            let newValue = event.target.value !== "" ? event.target.value : 0.0;
            this.purchase.sub0 = new Big(newValue).round(2);
            this.updateTotal();
        },
        onSub5Changed(event) {
            if (this.purchase.hasXMLLoaded) {
                return;
            }
            let newValue = event.target.value !== "" ? event.target.value : 0.0;
            this.purchase.sub5 = new Big(newValue);
            this.recalcManualTaxes();
        },
        onSub15Changed(event) {
            if (this.purchase.hasXMLLoaded) {
                return;
            }
            let newValue = event.target.value !== "" ? event.target.value : 0.0;
            this.purchase.sub15 = new Big(newValue);
            this.recalcManualTaxes();
        },
        onIceChanged(event) {
            if (this.purchase.hasXMLLoaded) {
                return;
            }
            let newValue = event.target.value !== "" ? event.target.value : 0.0;
            this.purchase.iceValue = new Big(newValue).round(2);
            this.updateTotal();
        },
        // Entrada manual: el IVA se calcula POR TARIFA (5% y general) en vez de
        // aplicar una sola tasa a toda la base gravada. `sub12` sigue siendo la
        // base gravada total, que es lo que persiste el backend como base12.
        recalcManualTaxes() {
            const generalRate = new Big(this.business.taxPercentage || '15').div(100);
            const tax5 = this.purchase.sub5.times(new Big('0.05'));
            const taxGen = this.purchase.sub15.times(generalRate);
            this.purchase.sub12 = this.purchase.sub5.plus(this.purchase.sub15).round(2);
            this.purchase.tax = tax5.plus(taxGen).round(2);
            this.updateTotal();
        },
        onTotalDiscountChanged(event) {
            // No permitir cambios si hay XML cargado
            if (this.purchase.hasXMLLoaded) {
                return;
            }
            let newValue = event.target.value !== "" ? event.target.value : 0.0;
            this.purchase.discount = new Big(newValue).round(2);
            this.updateTotal();
        },
        onTotalChanged(event) {
            // No permitir cambios si hay XML cargado
            if (this.purchase.hasXMLLoaded) {
                return;
            }
            let newValue = event.target.value !== "" ? event.target.value : 0.0;
            this.purchase.total = new Big(newValue).round(2);
        },
        updateTotal() {
            // Suma y resta usando Big. El ICE suma al total: es un impuesto que
            // el proveedor cobró, no una base.
            this.purchase.total = this.purchase.sub0
                .plus(this.purchase.sub12)
                .plus(this.purchase.iceValue)
                .plus(this.purchase.tax)
                .minus(this.purchase.discount)
                .round(2);
        },
        clearPurchase() {
            this.purchase = new Purchase();
            this.establishmentCode = null;
            this.emitionPointCode = null;
            this.serialNumber = null;
            this.receiptItems = [];
        },
        async savePurchase() {
            let result = this.checkForm();
            if (result !== "") {
                this.$toast.add({severity:'error', summary: 'Alerta', detail: result, life: 5000});
            } else {
                // Verificar si debe solicitar información de pago ANTES de guardar
                const hasAccountability = this.$store.getters.getUser && 
                    this.$store.getters.getUser.settings && 
                    this.$store.getters.getUser.settings.settings && 
                    this.$store.getters.getUser.settings.settings.account_enableAutoTransactions &&
                    this.$store.getters.getUser.settings.settings.account_enableAutoTransactions.value;
                
                const isNewPurchase = this.purchase.id === null; // Compra aún no tiene ID
                const isCreditPurchase = this.purchase.creditDays > 0; // Compra con plazo (por pagar)
                
                // Solo mostrar AccountEntry si:
                // 1. La contabilidad automática está activada
                // 2. Es una compra nueva (no se puede modificar después)
                // 3. NO es una compra a crédito (creditDays === 0, pago inmediato)
                if (hasAccountability === true && isNewPurchase && !isCreditPurchase) {
                    // Determinar el modo del AccountEntry según el método de pago
                    if (this.purchase.paymentMethod.code === 'MIXED') {
                        this.accountEntryMode = 'multiple';
                    } else {
                        this.accountEntryMode = 'simple';
                    }
                    
                    // Marcar que hay una compra pendiente de guardar
                    this.pendingPurchase = { };
                    
                    // Mostrar el AccountEntry para capturar info de pago
                    this.accountEntryDialog = true;
                    return; // Detener aquí, continuará en onSaveAccountEntry
                }

                // Si no requiere AccountEntry, proceder directamente
                await this.completeSaveProcess();
            }
        },

        async completeSaveProcess() {
            // Enable loading mode
            this.loadingSaveButton = true;

            // El cuerpo se arma aparte: si el servidor rechaza, el formulario conserva la
            // forma de pago y los porcentajes de retención (H26, H27).
            const payload = purchasePayload(this.purchase, {
                expenseType: this.selectedExpenseType ? this.selectedExpenseType.code : null,
                basicExpenseType: (this.selectedBasicExpenseType && this.showBasicExpenseType) ? this.selectedBasicExpenseType.code : null,
                makesRetention: this.business.makesRetention,
            });
            let response = await httpRequest.savePurchase(payload);

            // Disable loading mode
            this.loadingSaveButton = false;

            if (response.data !== undefined && response.data !== null) {
                this.purchase = new Purchase(response.data);
                this.setupUI();
                history.pushState(
                    {},
                    null,
                    this.$route.path + '?id=' + this.purchase.id
                )
            }
        
            if (response.status === 200) {
                if (this.business.makesRetention && this.purchase.hasRetention) {
                    this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Su comprobante de retención ha sido guardado y reportado al SRI.', life: 3000});
                } else {
                    this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Su compra/gasto ha sido guardada.', life: 3000});
                }
            } else if (response.status === 602 || response.status === 604) {
                // La compra quedó guardada; la firma o la dirección de la matriz no dejan emitir la retención.
                this.showRetentionError(response);
            } else if (response.status === 802) { 
                this.error.title = (response.error === "NO_DOC") ? "Documentos electrónicos agotados" : "Suscripción no válida";
                this.error.mensaje = "Su egreso ha sido guardado por el momento. Para generar el comprobante de retención por favor renueve su suscripción."
                this.subscriptionDialog = true;
            } else {
                // El backend dice qué falló (p. ej. un producto que ya no existe: la
                // compra se rechaza entera). Solo sin motivo cae al mensaje genérico.
                this.$toast.add({severity:'error', summary: 'No se guardó la compra', detail: response.error || 'Hemos detectado un error, por favor intente nuevamente.', life: response.error ? 8000 : 3000});
            }
        },
        async attemptToCreateRetention() {
            // Enable loading mode
            this.loadingCreateRetentionButton = true;

            // Solo viaja el id: no hay nada que convertir en el formulario (H26, H27).
            let response = await httpRequest.attemptToCreateRetention(this.purchase.id);

            // Disable loading mode
            this.loadingCreateRetentionButton = false;

            if (response.data !== undefined && response.data !== null) {
                this.purchase = new Purchase(response.data);
                this.setupUI();
                history.pushState(
                    {},
                    null,
                    this.$route.path + '?id=' + this.purchase.id
                )
            }
        
            if (response.status === 200) {
                this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Su comprobante de retención ha sido guardado y reportado al SRI.', life: 3000});
            } else if (response.status === 602 || response.status === 604) {
                this.showRetentionError(response);
            } else if (response.status === 802) { 
                this.error.title = (response.error === "NO_DOC") ? "Documentos electrónicos agotados" : "Suscripción no válida";
                this.error.mensaje = "Para poder generar el comprobante de retención por favor renueve su suscripción."
                this.subscriptionDialog = true;
            } else {
                this.$toast.add({severity:'error', summary: 'Error interno', detail: 'Hemos detectado un error, por favor intente nuevamente.', life: 3000});
            }
        },
        async viewTransaction() {
            if (!this.purchase.id) {
                this.noTransactionDialog = true;
                return;
            }

            this.loadingTransaction = true;
            try {
                const response = await httpRequest.getFinantialAccountTransaction(null, null, this.purchase.id);
                if (response.status === 200 && response.data && Array.isArray(response.data) && response.data.length > 0) {
                    this.transactionData = response.data;
                    this.transactionDialog = true;
                } else {
                    this.noTransactionDialog = true;
                }
            } catch (error) {
                console.error("Error fetching transaction:", error);
                this.noTransactionDialog = true;
            } finally {
                this.loadingTransaction = false;
            }
        },
        calculateTotalAmount() {
            if (!this.transactionData || this.transactionData.length === 0) {
                return '0.00';
            }
            // Las compras guardan el monto en negativo (salida de caja); se
            // muestra el valor absoluto sumado.
            const total = this.transactionData.reduce((sum, transaction) => {
                const amount = typeof transaction.amount === 'number' ? transaction.amount : parseFloat(transaction.amount || 0);
                return sum + Math.abs(amount);
            }, 0);
            return total.toFixed(2);
        },
        formatTransactionAmount(value) {
            if (value === null || value === undefined) {
                return '0.00';
            }
            const num = typeof value === 'number' ? value : parseFloat(value);
            if (isNaN(num)) {
                return '0.00';
            }
            // Valor absoluto: el signo negativo de la compra es implícito (es
            // una salida de caja) y no aporta al detalle mostrado.
            return Math.abs(num).toFixed(2);
        },
        formatTransactionDate(value) {
            if (!value) return '';
            const d = new Date(value);
            if (isNaN(d.getTime())) return value;
            return d.toLocaleString('es-EC', {
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit',
            });
        },
        paymentMethodLabel(code) {
            const map = {
                CASH: 'Efectivo',
                TRANSFER: 'Transferencia',
                DEBIT_CARD: 'Tarjeta de Débito',
                CREDIT_CARD: 'Tarjeta de Crédito',
                CHECK: 'Cheque',
                MIXED: 'Mixto',
            };
            return map[code] || 'Movimiento';
        },
        paymentMethodIcon(code) {
            const map = {
                CASH: 'pi pi-money-bill',
                TRANSFER: 'pi pi-send',
                DEBIT_CARD: 'pi pi-credit-card',
                CREDIT_CARD: 'pi pi-credit-card',
                CHECK: 'pi pi-file',
                MIXED: 'pi pi-th-large',
            };
            return map[code] || 'pi pi-wallet';
        },
        accountTypeLabel(code) {
            const map = { SAVING: 'Ahorros', CHECKING: 'Corriente' };
            return map[code] || code;
        },
        isImageProof(url) {
            if (!url || typeof url !== 'string') return false;
            return /\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i.test(url);
        },
        resolveProofUrl(url) {
            if (!url || typeof url !== 'string') return url;
            if (/^(https?:)?\/\//i.test(url) || /^data:/i.test(url)) return url;
            const base = this.$baseURL || '';
            const baseTrim = base.replace(/\/$/, '');
            const path = url.startsWith('/') ? url : '/' + url;
            return baseTrim + path;
        },
        openProof(proofUrl) {
            const finalUrl = this.resolveProofUrl(proofUrl);
            if (finalUrl) {
                window.open(finalUrl, '_blank', 'noopener,noreferrer');
            }
        },
        abonarPurchase() {
            // Abono (pago parcial): AccountEntry en modo 'partial' registra el
            // monto contra el endpoint registerPayment (ver onSaveAccountEntry).
            this.pendingPurchase = null;
            this.accountEntryMode = 'partial';
            this.accountEntryDialog = true;
        },
        async payPurchase() {
            // Una compra con abonos previos ya no puede ir por el batch de
            // pago completo (Σ amount == total + guardia de idempotencia).
            // "Pagar" pasa a ser "abonar el saldo completo".
            if (this.purchase.hasPartialPayments) {
                this.abonarPurchase();
                return;
            }

            const hasAccountability = this.$store.getters.getUser &&
                this.$store.getters.getUser.settings &&
                this.$store.getters.getUser.settings.settings &&
                this.$store.getters.getUser.settings.settings.account_enableAutoTransactions &&
                this.$store.getters.getUser.settings.settings.account_enableAutoTransactions.value;

            if (hasAccountability === true) {
                // Determinar el modo según el método de pago
                if (this.purchase.paymentMethod.code === 'MIXED') {
                    this.accountEntryMode = 'multiple';
                } else {
                    this.accountEntryMode = 'simple';
                }
                // No hay pendingPurchase porque la compra ya existe
                this.accountEntryDialog = true;
            } else {
                // Flujo original sin contabilidad automática
                this.loadingCollectButton = true;
                let response = await httpRequest.payPurchase(this.purchase.id);
                this.loadingCollectButton = false;
                if (response.status === 200) {
                    this.purchase = new Purchase(response.data);
                    this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Su compra ha sido pagada.', life: 3000});
                } else {
                    this.$toast.add({severity:'error', summary: 'Error interno', detail: 'Hemos detectado un error, por favor intente nuevamente.', life: 3000});
                }
            }
        },
        async deletePurchase(reportToSri = true) {
            // Igual que en ventas: sin credenciales no hay forma de informarle la
            // anulación al SRI, así que se pregunta antes en vez de anular en
            // silencio solo de este lado. Solo con retención autorizada: una que el
            // SRI no autorizó el backend la anula acá y listo.
            if (reportToSri && this.purchase.edoc && this.purchase.edoc.authorized === true && !(await this.refreshSriCredentials())) {
                this.showDeletePurchaseConfirmation = false;
                this.showSriCredentialsDialog = true;
                return;
            }

            this.showSriCredentialsDialog = false;
            this.annulmentInProgress = true;
            let response = await httpRequest.deletePurchase(this.purchase.id, reportToSri);
            if (response.status === 200) {
                // Con comprobante de retención hay que avisarle al SRI y ADEMÁS el
                // proveedor tiene que aceptar la anulación dentro de 5 días hábiles
                // (Res. NAC-DGERCGC25-00000014, Art. 4). Nada se revierte hasta
                // entonces: el comprobante sigue siendo válido.
                if (response.data !== null && response.data.async === true) {
                    showSriPendingToast(this.$toast, {summary: 'Anulación en curso', detail: response.data.message,
                        onTimeout: () => { this.annulmentInProgress = false; }});
                    this.showDeletePurchaseConfirmation = false;
                    return;
                }
                this.annulmentInProgress = false;
                if (response.data !== null) {
                    this.purchase = new Purchase(response.data);
                    this.setupUI();
                } else {
                    this.$router.push('/dashboard/compra/crud');
                }
            } else if (response.status === 422 && response.error) {
                this.$toast.add({severity:'warn', summary: 'No se puede anular', detail: response.error, life: 12000});
                this.annulmentInProgress = false;
                // Como en ventas: si el SRI sí autorizó la retención, el formulario lo muestra.
                let fresh = await httpRequest.getPurchase(this.purchase.id);
                if (fresh.status === 200) { this.purchase = new Purchase(fresh.data); this.setupUI(); }
            } else {
                this.$toast.add({severity:'error', summary: 'Error interno', detail: 'Hemos detectado un error, por favor intente nuevamente.', life: 3000});
                this.annulmentInProgress = false;
            }
            this.showDeletePurchaseConfirmation = false;
        },
        // Una sola accion, la que el aviso declare. Asi el modelo decide QUE se
        // puede hacer en cada estado y la plantilla no repite esa logica.
        onAnnulmentAction(name) {
            if (name === 'report') { return this.reportAnnulmentToSri() }
            if (name === 'check') { return this.checkAnnulmentStatus() }
        },
        async reportAnnulmentToSri() {
            if (this.purchase === null || !this.purchase.edoc) { return }
            if (!(await this.refreshSriCredentials())) { this.showSriCredentialsDialog = true; return }
            this.annulmentInProgress = true;
            let response = await httpRequest.reportAnnulmentToSri(this.purchase.edoc.id);
            if (response.status === 200 && response.data && response.data.async === true) {
                showSriPendingToast(this.$toast, {summary: 'Reportando al SRI', detail: response.data.message,
                    onTimeout: () => { this.annulmentInProgress = false; }});
                return;  // el resultado llega por WebSocket
            }
            this.annulmentInProgress = false;
            this.$toast.add({severity:'error', summary: 'No se pudo reportar',
                detail: response.error || 'Intenta de nuevo en un momento.', life: 10000});
        },
        // El store NO se rehidrata entre pestañas (ver saleForm.vue): antes de
        // frenar por falta de credenciales se le pregunta al backend.
        async refreshSriCredentials() {
            if (this.hasSriCredentials) { return true }
            const response = await httpRequest.syncAccount();
            if (response.status === 200 && response.data && response.data.business) {
                await this.$store.dispatch('setBusiness', new Business(response.data.business));
            }
            return this.hasSriCredentials;
        },
        goToSriCredentials() {
            window.open('/dashboard/general/informacion-basica?focus=sri-portal', '_blank');
            this.showSriCredentialsDialog = false;
            this.showAnnulmentOutcome = false;
        },
        // Desenlace de la anulacion, en Dialog (ver el comentario del template).
        // `action` (opcional) agrega un boton al dialogo; hoy solo 'sriCredentials'.
        setAnnulmentOutcome(title, icon, color, message, action = null) {
            this.annulmentOutcome = {title, icon, color, message, action};
            this.showAnnulmentOutcome = true;
        },
        // Desenlace de la anulación, por WebSocket. En retenciones lo normal es que
        // quede PENDIENTE esperando al proveedor, no anulada.
        async onAnnulmentResult(data) {
            if (!data || this.purchase === null || !this.purchase.edoc) { return }
            if (data.edocId !== this.purchase.edoc.id) { return }
            clearSriPendingToast(this.$toast);

            this.annulmentInProgress = false;
            if (data.status !== 'ok') {
                this.setAnnulmentOutcome('No se pudo anular', 'pi-times-circle', 'red', data.message);
            } else if (data.state === 'accepted') {
                this.setAnnulmentOutcome('Comprobante anulado', 'pi-check-circle', 'green', data.message);
            } else {
                // El proveedor tiene 5 días hábiles y hasta entonces la retención
                // SIGUE SIENDO VÁLIDA. Es el desenlace que más hay que leer.
                this.setAnnulmentOutcome('Esperando al proveedor', 'pi-clock', 'orange', data.message);
            }

            let response = await httpRequest.getPurchase(this.purchase.id);
            if (response.status === 200) {
                this.purchase = new Purchase(response.data);
                this.setupUI();
            }
        },
        async checkAnnulmentStatus() {
            if (this.purchase === null || !this.purchase.edoc) { return }
            this.annulmentInProgress = true;
            let response = await httpRequest.checkAnnulmentStatus(this.purchase.edoc.id);
            if (response.status === 200 && response.data && response.data.async === true) {
                showSriPendingToast(this.$toast, {summary: 'Consultando al SRI', detail: response.data.message,
                    onTimeout: () => { this.annulmentInProgress = false; }});
                return;  // el resultado llega por WebSocket
            }
            this.annulmentInProgress = false;
            if (response.status === 200) {
                let purchase = await httpRequest.getPurchase(this.purchase.id);
                if (purchase.status === 200) { this.purchase = new Purchase(purchase.data); this.setupUI(); }
                // Mismo texto y misma longitud que el desenlace por WebSocket, asi
                // que mismo tratamiento: Dialog, no toast.
                this.setAnnulmentOutcome('Estado actualizado', 'pi-info-circle', 'blue',
                    (this.purchase.edoc && this.purchase.edoc.annulmentMessage) || 'El comprobante ya no tiene una anulación en curso.');
            } else if (response.status === 422 && response.error) {
                // Respuesta del backend que hay que leer con calma (p. ej. sin
                // credenciales: desde cuando se confirmara solo). Dialog, no toast.
                const missingCredentials = !!(response.data && response.data.reason === 'sriCredentialsMissing');
                this.setAnnulmentOutcome('Consulta al SRI', 'pi-info-circle', 'blue', response.error,
                    missingCredentials ? 'sriCredentials' : null);
            } else {
                this.$toast.add({severity:'error', summary: 'No se pudo consultar',
                    detail: response.error || 'Intenta de nuevo en un momento.', life: 8000});
            }
        },
        async downloadPurchase(type) {
            if (type === 'pdf') {
                this.loadingDownloadGuideButton = true;
                try {
                    const response = await httpRequest.downloadPurchase(this.purchase.id, type);
                    await saveDownload(response, "compr_retencion_" + this.purchase.edoc.serial + ".pdf", "application/pdf", this.$toast);
                } finally {
                    this.loadingDownloadGuideButton = false;
                }
            } else if (type === 'xml') {
                this.loadingDownloadGuideButton = true;
                try {
                    const response = await httpRequest.downloadPurchase(this.purchase.id, type);
                    if (await saveDownload(response, "compr_retencion_" + this.purchase.edoc.serial + ".xml", "application/xml", this.$toast)) {
                        const notice = await authorizedXmlNotice(response);
                        if (notice) this.$toast.add(notice);
                    }
                } finally {
                    this.loadingDownloadGuideButton = false;
                }
            }
        },
        onCreditDaysChanged() {
            this.purchase.creditDays = parseInt(this.creditDay.code);
        },
        getCreditDayDic(creditDays) {
            for (var i in this.creditDays) {
                if (this.creditDays[i].code == creditDays) { return this.creditDays[i]; }  
            }
            return this.creditDays[0];
        },
        displayDeletePurchaseConfirmation(show) {
            this.showDeletePurchaseConfirmation = show;
        },
        async searchProvider(event) {
            let response = await httpRequest.getProviders(true, event.query);
            if (response.status == 200) {
				this.providers = response.data.map(provider => { return new ProductProvider(provider) })
            } else { this.providers = [] }
        },
        onProviderSelected(event) {
            this.purchase.vendorName = event.value.company;
            this.purchase.vendorIdentification = event.value.companyIdentification;
            this.purchase.rentPercentage = this.purchase.getRentPercentageOption(event.value.rentRetentionPercentage);
            this.purchase.ivaPercentage = this.purchase.getIVAPercentageOption(event.value.ivaRetentionPercentage);
        },
        closeSubscriptionDialog() {
            this.subscriptionDialog = false;
        },
        redirectToSubscription() {
            this.subscriptionDialog = false;
            this.$router.push('/dashboard/general/suscripcion');
        },
        
        // Account Entry Delegate
        async onSaveAccountEntry(data) {
            this.accountEntryDialog = false;

            // Modo abono: registrar el pago parcial y refrescar la compra con
            // la respuesta (el backend marca PAID si el saldo llegó a cero).
            if (data.partial === true) {
                const response = await httpRequest.registerPayment({
                    purchaseId: this.purchase.id,
                    amount: data.amount,
                    accountId: data.accountId,
                    paymentMethod: data.paymentMethod,
                    approvalNumber: data.approvalNumber,
                    proof: data.proof,
                });

                if (response.status === 200 && response.data) {
                    this.purchase = new Purchase(response.data);
                    if (this.purchase.status === 'PAID') {
                        this.$toast.add({severity:'success', summary: 'Compra pagada', detail: 'El abono completó el total y la compra quedó pagada', life: 4000});
                    } else {
                        this.$toast.add({severity:'success', summary: 'Abono registrado', detail: `Abono de $${data.amount.toFixed(2)} registrado. Saldo pendiente: $${this.purchase.pendingAmount !== null ? this.purchase.pendingAmount.toFixed(2) : '-'}`, life: 4000});
                    }
                } else if (isAlreadyCollected(response)) {
                    await this.onAlreadyPaid(response);
                } else if (response.status === 422 && response.error) {
                    this.$toast.add({severity:'error', summary: 'Abono rechazado', detail: response.error, life: 5000});
                } else {
                    this.$toast.add({severity:'error', summary: 'Error registrando abono', detail: 'Por favor intente nuevamente, si el error continua comuníquese con el proveedor.', life: 4000});
                }
                return;
            }

            // Si NO hay compra pendiente, es caso de payPurchase (pagar compra existente)
            if (this.pendingPurchase === null) {
                this.loadingCollectButton = true;
                
                try {
                    // Determinar si es modo simple o múltiple
                    const isMultipleMode = this.accountEntryMode === 'multiple';
                    
                    if (isMultipleMode) {
                        // Modo múltiple: data = { transactions: [...], totalTip: X }
                        const { transactions } = data;
                        
                        // Preparar transacciones con referencias correctas
                        const preparedTransactions = transactions.map((transaction) => {
                            let reference;
                            if (this.purchase.edoc !== null && this.purchase.edoc !== undefined) {
                                reference = "COMPROBANTE RETENCIÓN " + this.purchase.edoc.sequence;
                            } else {
                                reference = "COMPRA " + this.purchase.id.toString().padStart(8, "0");
                            }
                            
                            // Agregar método de pago a la referencia
                            reference += " - " + transaction.paymentMethodName;
                            
                            // Agregar número de aprobación si existe
                            if (transaction.approvalNumber) {
                                reference += " - Aprobación: " + transaction.approvalNumber;
                            }
                            
                            return {
                                accountId: transaction.accountId,
                                amount: -Math.abs(transaction.amount), // Negativo para compras
                                reference: reference,
                                purchaseId: this.purchase.id,
                                tip: 0, // Las compras no tienen propina
                                paymentMethod: transaction.paymentMethod,
                                approvalNumber: transaction.approvalNumber || null,
                                proof: transaction.proof || null
                            };
                        });
                        
                        // Crear todas las transacciones
                        const transactionResponse = await httpRequest.createMultipleTransactions(preparedTransactions);
                        
                        if (transactionResponse.status === 200) {
                            // Marcar la compra como pagada en el backend
                            const payResponse = await httpRequest.payPurchase(this.purchase.id);
                            if (payResponse.status === 200 && payResponse.data !== null) {
                                this.purchase = new Purchase(payResponse.data);
                                this.setupUI();
                                this.$toast.add({severity:'success', summary: 'Éxito', detail: `Se registraron ${preparedTransactions.length} pagos correctamente`, life: 3000});
                            }
                        } else if (isAlreadyCollected(transactionResponse)) {
                            await this.onAlreadyPaid(transactionResponse);
                        } else {
                            this.$toast.add({severity:'error', summary: 'Error', detail: rejectionDetail(transactionResponse, 'Error al crear las transacciones.'), life: 6000});
                        }
                    } else {
                        // Modo simple: data = { accountId, accountName, amount, tip, approvalNumber, proof, paymentMethod }
                        const { accountId, amount, approvalNumber, proof, paymentMethod } = data;
                        
                        // Construir referencia
                        let reference;
                        if (this.purchase.edoc !== null && this.purchase.edoc !== undefined) {
                            reference = "COMPROBANTE RETENCIÓN " + this.purchase.edoc.sequence;
                        } else {
                            reference = "COMPRA " + this.purchase.id.toString().padStart(8, "0");
                        }
                        
                        if (approvalNumber) {
                            reference += " - Aprobación: " + approvalNumber;
                        }
                        
                        // Crear la transacción vía el endpoint batch (1 item).
                        const transactionResponse = await httpRequest.createMultipleTransactions([{
                            accountId,
                            amount: -Math.abs(amount), // Negativo para compras
                            reference,
                            purchaseId: this.purchase.id,
                            tip: 0, // Las compras no tienen propina
                            paymentMethod: paymentMethod || null,
                            approvalNumber: approvalNumber || null,
                            proof: proof || null,
                        }]);
                        
                        if (transactionResponse.status === 200) {
                            // Marcar la compra como pagada en el backend
                            const payResponse = await httpRequest.payPurchase(this.purchase.id);
                            if (payResponse.status === 200 && payResponse.data !== null) {
                                this.purchase = new Purchase(payResponse.data);
                                this.setupUI();
                                this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Nuevo egreso de caja registrado', life: 3500});
                            }
                        } else if (isAlreadyCollected(transactionResponse)) {
                            await this.onAlreadyPaid(transactionResponse);
                        } else {
                            this.$toast.add({severity:'error', summary: 'Error', detail: rejectionDetail(transactionResponse, 'Error al crear la transacción.'), life: 6000});
                        }
                    }
                } catch (error) {
                    console.error('Error pagando compra:', error);
                    this.$toast.add({severity:'error', summary: 'Error', detail: 'Error inesperado al procesar el pago', life: 3000});
                } finally {
                    this.loadingCollectButton = false;
                }
                
                return;
            }
            
            // FLUJO CORRECTO: Guardar info de pago temporalmente
            this.loadingSaveButton = true;
            
            try {
                // Determinar si es modo simple o múltiple
                const isMultipleMode = this.accountEntryMode === 'multiple';
                
                let capturedTransactionData = null;
                
                if (isMultipleMode) {
                    // Modo múltiple: data = { transactions: [...], totalTip: X }
                    const { transactions } = data;
                    
                    // Las compras no tienen propina, así que no guardamos totalTip
                    
                    capturedTransactionData = { transactions, isMultiple: true };
                } else {
                    // Modo simple: data es el objeto de transacción capturado por AccountEntry
                    // data = { accountId, accountName, amount, tip, approvalNumber, proof, paymentMethod, reference }
                    // Note: tip siempre es 0 para compras (AccountEntry lo garantiza)
                    
                    capturedTransactionData = { transactionData: data, isMultiple: false };
                }
                
                // PASO 1: Guardar el purchase primero
                // El cuerpo se arma aparte, sin tocar el formulario (H26, H27).
                const payload = purchasePayload(this.purchase, {
                    expenseType: this.selectedExpenseType ? this.selectedExpenseType.code : null,
                    basicExpenseType: (this.selectedBasicExpenseType && this.showBasicExpenseType) ? this.selectedBasicExpenseType.code : null,
                    makesRetention: this.business.makesRetention,
                });

                const purchaseResponse = await httpRequest.savePurchase(payload);
                // La compra quedó guardada aunque el comprobante de retención falló
                // (SRI, firma, cupo): el pago capturado se registra igual (H66).
                const retentionFailed = documentSavedDespiteReceiptError(purchaseResponse);

                if ((purchaseResponse.status !== 200 && !retentionFailed) || !purchaseResponse.data) {
                    this.loadingSaveButton = false;
                    this.$toast.add({severity:'error', summary: 'No se guardó la compra', detail: purchaseResponse.error || 'Error al guardar la compra', life: purchaseResponse.error ? 8000 : 3000});
                    this.pendingPurchase = null;
                    return;
                }
                
                // Actualizar el objeto purchase con los datos guardados (incluye el ID)
                this.purchase = new Purchase(purchaseResponse.data);
                
                // Actualizar URL con el ID de la compra
                history.pushState(
                    {},
                    null,
                    this.$route.path + '?id=' + this.purchase.id
                );
                
                // PASO 2: Ahora crear la(s) transacción(es) financiera(s)
                if (capturedTransactionData.isMultiple) {
                    // Modo múltiple: Preparar transacciones con la referencia correcta
                    const preparedTransactions = capturedTransactionData.transactions.map((transaction) => {
                        // Construir la referencia base según el tipo de documento
                        let reference;
                        if (this.purchase.edoc !== null && this.purchase.edoc !== undefined) {
                            reference = "COMPROBANTE RETENCIÓN " + this.purchase.edoc.sequence;
                        } else {
                            reference = "COMPRA " + this.purchase.id.toString().padStart(8, "0");
                        }
                        
                        // Agregar método de pago a la referencia
                        reference += " - " + transaction.paymentMethodName;
                        
                        // Agregar número de aprobación si existe
                        if (transaction.approvalNumber) {
                            reference += " - Aprobación: " + transaction.approvalNumber;
                        }
                        
                        // Retornar transacción preparada
                        return {
                            accountId: transaction.accountId,
                            amount: -Math.abs(transaction.amount), // Negativo para compras
                            reference: reference,
                            purchaseId: this.purchase.id,
                            tip: 0, // Las compras no tienen propina
                            paymentMethod: transaction.paymentMethod,
                            approvalNumber: transaction.approvalNumber || null,
                            proof: transaction.proof || null
                        };
                    });
                    
                    // Crear todas las transacciones
                    const transactionResponse = await httpRequest.createMultipleTransactions(preparedTransactions);
                    
                    if (transactionResponse.status === 200) {
                        // El batch backend ya marcó la compra como PAID.
                        this.purchase.collectStatus = "PAID";
                        this.setupUI();
                        this.$toast.add({
                            severity:'success', 
                            summary: 'Éxito', 
                            detail: `Compra guardada con ${preparedTransactions.length} transacciones registradas`, 
                            life: 3000
                        });
                    } else if (isAlreadyCollected(transactionResponse)) {
                        await this.onAlreadyPaid(transactionResponse);
                    } else {
                        // Purchase guardado pero transacciones fallaron;
                        // queda PENDING en backend para reintento vía "Pagar".
                        this.setupUI();
                        this.$toast.add({
                            severity:'warn', 
                            summary: 'Advertencia', 
                            detail: rejectionDetail(transactionResponse, 'Compra guardada pero hubo un error al registrar las transacciones. Use el botón "Pagar" para reintentar.'),
                            life: 5000
                        });
                    }
                } else {
                    // Modo simple: crear la transacción con el purchase ID correcto
                    const txData = capturedTransactionData.transactionData;
                    
                    // Construir la referencia correcta ahora que tenemos el purchase guardado
                    let reference;
                    if (this.purchase.edoc !== null && this.purchase.edoc !== undefined) {
                        reference = "COMPROBANTE RETENCIÓN " + this.purchase.edoc.sequence;
                    } else {
                        reference = "COMPRA " + this.purchase.id.toString().padStart(8, "0");
                    }
                    
                    // Agregar número de aprobación si existe
                    if (txData.approvalNumber) {
                        reference += " - Aprobación: " + txData.approvalNumber;
                    }
                    
                    // Crear la transacción vía el endpoint batch (1 item) ahora que
                    // tenemos el purchase guardado y su ID real.
                    const transactionResponse = await httpRequest.createMultipleTransactions([{
                        accountId: txData.accountId,
                        amount: -Math.abs(txData.amount), // Negativo para compras
                        reference,
                        purchaseId: this.purchase.id,
                        tip: txData.tip || 0,
                        paymentMethod: txData.paymentMethod || null,
                        approvalNumber: txData.approvalNumber || null,
                        proof: (txData.proof !== null && txData.proof !== undefined) ? txData.proof : null,
                    }]);
                    
                    if (transactionResponse.status === 200) {
                        // El batch backend ya marcó la compra como PAID.
                        this.purchase.collectStatus = "PAID";
                        this.setupUI();
                        if (retentionFailed) {
                            this.$toast.add({severity:'info', summary: 'Pago registrado', detail: 'La compra quedó guardada y pagada.', life: 4000});
                        } else if (this.business.makesRetention && this.purchase.hasRetention) {
                            this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Comprobante de retención guardado y transacción registrada', life: 3000});
                        } else {
                            this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Compra guardada y transacción registrada', life: 3000});
                        }
                    } else if (isAlreadyCollected(transactionResponse)) {
                        await this.onAlreadyPaid(transactionResponse);
                    } else {
                        // Purchase guardado pero transacción falló;
                        // queda PENDING en backend para reintento vía "Pagar".
                        this.setupUI();
                        this.$toast.add({
                            severity:'warn', 
                            summary: 'Advertencia', 
                            detail: rejectionDetail(transactionResponse, 'Compra guardada pero hubo un error al registrar la transacción. Use el botón "Pagar" para reintentar.'),
                            life: 5000
                        });
                    }
                }
                
                this.pendingPurchase = null; // Limpiar
                this.loadingSaveButton = false;
                if (retentionFailed) this.showRetentionError(purchaseResponse);

            } catch (error) {
                console.error('Error en proceso de guardado:', error);
                this.loadingSaveButton = false;
                this.pendingPurchase = null;
                this.$toast.add({severity:'error', summary: 'Error', detail: 'Error inesperado al procesar la compra', life: 3000});
            }
        },
        // El pago ya estaba registrado (910): se avisa y se recarga la compra como la ve el
        // backend, sin invitar a reintentar.
        async onAlreadyPaid(response) {
            this.$toast.add(alreadyCollectedToast(response, 'Esta compra ya fue pagada'));
            const fresh = await httpRequest.getPurchase(this.purchase.id);
            if (fresh.status === 200) {
                this.purchase = new Purchase(fresh.data);
                this.setupUI();
            }
        },
        // La compra quedó guardada (y pagada) pero el comprobante de retención no
        // salió: se dice por qué, igual que en el guardado sin AccountEntry (H66).
        showRetentionError(response) {
            if (response.status === 802) {
                this.error.title = (response.error === "NO_DOC") ? "Documentos electrónicos agotados" : "Suscripción no válida";
                this.error.mensaje = "Su egreso ha sido guardado por el momento. Para generar el comprobante de retención por favor renueve su suscripción.";
                this.subscriptionDialog = true;
                return;
            }
            const detail = (typeof response.error === 'string' && response.error)
                ? response.error
                : 'La compra quedó guardada y pagada, pero el comprobante de retención no se emitió.';
            this.$toast.add({severity:'warn', summary: 'Comprobante de retención no emitido', detail, life: 8000});
        },
        onCancelAccountEntry() {
            this.accountEntryDialog = false;
            this.pendingPurchase = null; // Limpiar pendiente si el usuario cancela
            // Revertir los botones de loading si estaban activos
            this.loadingSaveButton = false;
        },
    },
    components: {
        'AccountEntry': AccountEntry,
        'PaymentHistoryDialog': PaymentHistoryDialog,
        'ObservationsField': ObservationsField,
    },
}
</script>

<style scoped lang="scss">
/* Accion del aviso de anulacion.
   Dos correcciones sobre el default de PrimeVue en esta pantalla:
   - `width: auto` porque el formulario es `p-fluid` y estiraba el boton al 100%,
     lo que empujaba el icono a un extremo y el texto al otro.
   - Contorno en vez de `p-button-text`, que se leia como un enlace y no como
     algo que se pueda pulsar.
   El color sale de `--notice-accent`, que el aviso fija inline segun su estado,
   asi el boton vive en la misma tonalidad del panel en los cinco casos. */
.annulmentNoticeAction {
    width: auto;
    background: transparent;
    color: var(--notice-accent-strong);
    border: 1px solid var(--notice-accent);
    font-weight: 600;
}
.annulmentNoticeAction:enabled:hover,
.annulmentNoticeAction:enabled:focus {
    background: var(--notice-accent);
    border-color: var(--notice-accent);
    color: #fff;
    box-shadow: none;
}

    .menuButton {
        width: 100%;
        background-color: white;
        border: 0px;
        color: darkgrey;
    }
    .menuButton:hover {
        background-color: gray;
    }

    /* "Cargar XML" (FileUpload basic) ocupa todo el ancho de su columna para
       alinearse con el botón "Descargar del SRI" que va al lado. */
    ::v-deep(.xmlUploadField .p-fileupload),
    ::v-deep(.xmlUploadField .p-fileupload-basic) {
        width: 100%;
    }
    ::v-deep(.xmlUploadField .p-button) {
        width: 100%;
        justify-content: center;
    }

    @media screen and (max-width: 769px) {
        .number-textfield {
            width: 150px;
            height: 30px;
            font-size: 13px;;
        }
        .purchaseTopContainer {
            margin-top: 10px;
        }
        .purchaseReceiptContainer {
            width: 100%; 
            display: block;
        }
        .providerContainer {
            width: 100%;
            margin-right: 0px;
        }
        .providerIdContainer {
            width: 100%;
            margin-right: 0px;
        }
        .receiptSerialContainer {
            width: 100%;
            margin-right: 0px;
        }
        .receiptDateContainer {
            width: 100%;
        }
        .retentionContainer {
            width: 100%;
        }
        .saleFormButtonContainer {
            display: block;
        }
        .paymentContainer {
            display: initial;
        }
        .paymentContainer > div > h5 {
            margin: 10px 0 5px 0; 
        }
        .paymentSubcontainer {
            display: block;
        }
        .collectButton {
            margin-top: 10px;
            padding: 0px;
            min-width: 100px;
        }
        .SaleInformationLabel {
            width: 150px;
            margin-bottom: 15px;
        }
        .selectButton {
            width: 100%; 
            margin: 0rem auto 1.5rem auto;
        }
        .expenseDetailContainer {
            display: block;
        }
        .expenseDetailContainer > div {
            padding-left: 0px;
        }
    }
    @media screen and (min-width: 769px) {
        .number-textfield {
            margin: 0px 0px 10px auto;
            width: 100px;
            height: 30px;
            font-size: 15px;

        }
        .purchaseReceiptContainer {
            width: 100%; 
            display: flex;
        }
        .providerContainer {
            width: 40%;
            margin-right: 20px;
        }
        .providerIdContainer {
            width: 20%;
            margin-right: 20px;
        }
        .receiptSerialContainer {
            width: 20%;
            margin-right: 20px;
        }
        .receiptDateContainer {
            width: 20%;
        }
        .retentionContainer {
            width: 250px;
        }
        .saleFormButtonContainer {
            display: flex;
        }
        .saleInformationContainer {
            padding-left: 50px;
        }
        .paymentContainer {
            display: flex;
            margin-bottom: 5px;
        }
        .paymentContainer > div > h5 {
            margin-bottom: 5px; 
        }
        .paymentSubcontainer {
            display: flex;
        }
        .collectButton {
            margin-left: 10px;
            max-width: 150px;
        }
        .download-button {
            width: 180px;
        }
        .selectButton {
            width: 30%; 
            min-width: 375px; 
            margin: 0rem auto 3rem 0rem;
        }
        .expenseDetailContainer {
            display: flex;
        }
        .expenseDetailContainer > div {
            padding-left: 1rem;
        }
    }

    // Estilos para el dialog de transacción
    .transaction-card {
        transition: all 0.3s ease;
    }

    .transaction-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 12px rgba(0,0,0,0.15) !important;
    }

    ::v-deep(.transaction-dialog) {
        .p-dialog-header {
            background: linear-gradient(135deg, #18407f 0%, #27285c 100%);
            color: white;
            border-radius: 12px 12px 0 0;
            padding: 1.5rem;
        }

        .p-dialog-content {
            padding: 1.5rem;
            background: #eeedef;

            /* Custom scrollbar */
            ::-webkit-scrollbar {
                width: 8px;
            }

            ::-webkit-scrollbar-track {
                background: #eeedef;
                border-radius: 4px;
            }

            ::-webkit-scrollbar-thumb {
                background: #18407f;
                border-radius: 4px;
            }

            ::-webkit-scrollbar-thumb:hover {
                background: #27285c;
            }
        }

        .p-dialog-footer {
            background: #eeedef;
            border-top: 1px solid #d1d5db;
            padding: 1rem 1.5rem;
        }
    }

    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .transaction-card {
        animation: fadeInUp 0.4s ease-out;
    }
</style>